<template>
  <FinanceControlShell class="accounts-advance-page">
    <loading :active.sync="loading" />
    <template slot="tabs">
      <SegmentedControl
        class="m-b-20 pt-0 accounts-primary-tabs"
        aria-label="Finance control section"
        :value="changeTab"
        :options="[
          {
            label: 'Jobs Payment Detail',
            value: 'paymentDetail',
            icon: 'work_outline',
          },
          {
            label: 'Assignment Payment Details',
            value: 'advanceDetail',
            icon: 'assignment',
          },
        ]"
        @change="filterByTab"
      />
    </template>
      <!-- <v-tab
        v-if="workingCountry.includes('UAE') || workingCountry.includes('KSA')"
        :href="`#customerDetail`"
        @click="filterByTab('customerDetail')"
        >Customer Receipt
      </v-tab> -->
    <v-flex xs2 class="reset__btn accounts-advance-bulk-actions">
      <AssignmentInvoicePopup
        v-if="
          this.searchTypes.abbr == 'jobId' ||
          this.searchTypes.abbr == 'assignmentId'
        "
        :assignmentIds="this.selectednames"
        :countInvoice="generateInvoiceCount"
        :selectedCustomerForInvoice="selectedCustomerDataInvoice"
        @reset-list="resetInvoiceIds"
      />
      <MultipleAssignmentPopup
        v-if="this.searchTypes.abbr == 'driverId'"
        :assignmentIds="this.selectednames"
        :countInvoice="generateInvoiceCount"
        :type="'Driver'"
        :selectedCustomerForInvoice="selectedCustomerDataInvoice"
        @payment-list-refresh-multiple="refreshMultiple()"
        @reset-list="resetInvoiceIds"
      />
      <MultipleAssignmentPopup
        v-if="this.searchTypes.abbr == 'transporterId'"
        :type="'Transporter'"
        :assignmentIds="this.selectednames"
        :countInvoice="generateInvoiceCount"
        :selectedCustomerForInvoice="selectedCustomerDataInvoice"
        @payment-list-refresh-multiple="refreshMultiple()"
        @reset-list="resetInvoiceIds"
      />
    </v-flex>

    <v-card-title
      class="bg-clr"
      style="margin-top: 5px"
      v-if="
        advanceRequestedAmount ||
        advanceRequested ||
        advanceReadyToPayAmount ||
        advanceReadyToPay ||
        advancePaidTotalAmount ||
        advancePaidAmount ||
        finalReadyToPay ||
        finalPayment ||
        readyToPayAmount ||
        readyToPay ||
        failedAdvanceAmount ||
        failedAdvanceAmountCount ||
        totalPendingFinalPayAmount ||
        totalPendingFinalPayCount ||
        finalPaymentRbFailedAmount ||
        finalPaymentRbFailedCount ||
        totalFinalFailedAmount ||
        totalFinalFailedCount ||
        internalFailedCount ||
        internalFailedAmount
      "
    >
      <v-layout v-if="advanceStatus && assignStatus"></v-layout>
      <v-layout
        v-else-if="assignStatus == 'Driver Partially Assigned'"
      ></v-layout>
      <v-layout
        class="accounts-payment-summary-grid"
        v-else
      >
        <v-flex xs3 pr-6 v-if="advanceStatus && !assignStatus">
          <v-layout>
            <span> Advance Requested</span>
          </v-layout>

          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Amount</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar"
              >
                <span class="count">{{ advanceRequestedAmount || "0" }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Count</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar"
              >
                <span class="count">{{ advanceRequested || "0" }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs3 pr-4 v-if="advanceStatus && !assignStatus">
          <v-layout>
            <span>Advance Ready to Pay</span>
          </v-layout>

          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Amount</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar new"
              >
                <span class="count breakword">{{
                  advanceReadyToPayAmount || "0"
                }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Count</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar"
              >
                <span class="count">{{ advanceReadyToPay || "0" }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs3 pr-4 v-if="advanceStatus && !assignStatus">
          <v-layout>
            <span> Advance Paid</span>
          </v-layout>

          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Amount</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar new"
              >
                <span class="count breakword">{{
                  advancePaidTotalAmount || "0"
                }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Count</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar"
              >
                <span class="count">{{ advancePaidAmount || "0" }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- <v-flex xs3 pr-4>
          <v-layout>
            <span> Final Payment</span>
          </v-layout>

          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Amount</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar new"
              >
                <span class="count breakword">{{
                  finalReadyToPay || "0"
                }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Count</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar"
              >
                <span class="count">{{ finalPayment || "0" }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex> -->
        <!-- <v-flex xs3 pr-2 pl-3>
          <v-layout>
            <span> Ready To Pay</span>
          </v-layout>

          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Amount</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar new"
              >
                <span class="count breakword">{{
                  readyToPayAmount || "0"
                }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Count</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar"
              >
                <span class="count">{{ readyToPay || "0" }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex> -->
        <v-flex xs3 pr-2 pl-3 v-if="advanceStatus && !assignStatus">
          <v-layout>
            <span> Advance Failed To Pay</span>
          </v-layout>

          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Amount</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar new"
              >
                <span class="count breakword">{{
                  failedAdvanceAmount || "0"
                }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              v-if="failedAdvanceAmountCount > 0 && rbretryButtonShow"
              xs4
              pt-3
            >
              <span class="muted">Count</span>
            </v-flex>
            <v-flex v-else xs3 pt-3>
              <span class="muted">Count</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar"
              >
                <span class="count">{{ failedAdvanceAmountCount || "0" }}</span>
                <v-btn
                  v-if="failedAdvanceAmountCount > 0 && rbretryButtonShow"
                  class="advance-btn-color pl-2"
                  style="padding: 15px !important"
                  flat
                  prepend-icon
                  color="white "
                  @click="openRetryAllpopup('advance')"
                >
                  Retry All</v-btn
                >

                <div
                  style="
                    color: red;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 5px !important;
                  "
                  class="pl-1"
                  v-if="failedAdvanceAmountCount > 0 && !rbretryButtonShow"
                >
                  <v-tooltip
                    top
                    content-class="tooltip-op"
                    style="margin: 0 10px 2px 0 !important"
                  >
                    <span
                      slot="activator"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: white !important;
                        background: red !important;
                        padding: 3px !important;
                        border-radius: 100% !important;
                        height: 20px !important;
                        width: 20px !important;
                        text-align: center !important;
                      "
                    >
                      i
                    </span>
                    <span class="tooltip">Connect To Technical team</span>
                  </v-tooltip>
                </div>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex
          xs3
          pr-2
          pl-3
          v-if="!advanceStatus && assignStatus == 'Payment Pending'"
        >
          <v-layout>
            <span> Total Final Pending</span>
          </v-layout>

          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Amount</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar new pl-4"
              >
                <span class="count breakword">{{
                  totalPendingFinalPayAmount || "0"
                }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Count</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar"
              >
                <span class="count">{{
                  totalPendingFinalPayCount || "0"
                }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs3 pr-2 pl-3 v-if="!advanceStatus && assignStatus">
          <v-layout>
            <span> Total Final Failed</span>
          </v-layout>

          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Amount</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar new"
              >
                <span class="count breakword">{{
                  totalFinalFailedAmount || "0"
                }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Count</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar"
              >
                <span class="count">{{ totalFinalFailedCount || "0" }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          xs3
          pr-2
          pl-3
          v-if="!advanceStatus && assignStatus == 'Payment Pending'"
        >
          <v-layout>
            <span> OMS Failed Final Payment</span>
          </v-layout>

          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Amount</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar new"
              >
                <span class="count breakword">{{
                  internalFailedAmount || "0"
                }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Count</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar"
              >
                <span class="count">{{ internalFailedCount || "0" }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          xs3
          pr-2
          pl-3
          v-if="!advanceStatus && assignStatus == 'Payment Pending'"
        >
          <v-layout>
            <span>RB Failed Final Payment</span>
          </v-layout>

          <v-layout>
            <v-flex xs3 pt-3>
              <span class="muted">Amount</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar new"
              >
                <span class="count breakword">{{
                  finalPaymentRbFailedAmount || "0"
                }}</span>
              </v-avatar>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              v-if="finalPaymentRbFailedCount > 0 && rbretryButtonShowFinal"
              xs4
              pt-3
            >
              <span class="muted">Count</span>
            </v-flex>
            <v-flex v-else xs3 pt-3>
              <span class="muted">Count</span>
            </v-flex>
            <v-flex>
              <v-avatar
                tile
                color="#ffa500"
                class="total avatar"
              >
                <span class="count">{{
                  finalPaymentRbFailedCount || "0"
                }}</span>
                <v-btn
                  v-if="finalPaymentRbFailedCount > 0 && rbretryButtonShowFinal"
                  class="advance-btn-color pl-2"
                  style="padding: 15px !important"
                  flat
                  prepend-icon
                  color="white "
                  @click="openRetryAllpopup('final')"
                >
                  Retry All</v-btn
                >

                <div
                  style="
                    color: red;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 5px !important;
                  "
                  class="pl-1"
                  v-if="
                    finalPaymentRbFailedCount > 0 && !rbretryButtonShowFinal
                  "
                >
                  <v-tooltip
                    top
                    content-class="tooltip-op"
                    style="margin: 0 10px 2px 0 !important"
                  >
                    <span
                      slot="activator"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: white !important;
                        background: red !important;
                        padding: 3px !important;
                        border-radius: 100% !important;
                        height: 20px !important;
                        width: 20px !important;
                        text-align: center !important;
                      "
                    >
                      i
                    </span>
                    <span class="tooltip">Connect To Technical team</span>
                  </v-tooltip>
                </div>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          xs3
          pr-2
          pl-3
          v-if="
            !advanceStatus &&
            assignStatus == 'Payment Pending' &&
            finalPaymentRbFailedCount > 0
          "
        >
          <v-layout>
            <!-- <span> Total RB Failed Entry for Final Payment </span> -->
          </v-layout>
          <v-switch
            color="green"
            v-model="finalPaymentStatus"
            :label="'See Failed  Final Payments'"
            @change="searchData()"
          ></v-switch>
          <!-- <v-radio-group
            v-model="finalPaymentStatus"
            :mandatory="true"
            :rules="[rules.required]"
            @change="searchData()"
          >
            <div>
              <div class>
                <v-radio
                  label=" Final Pending Payments"
                  value="false"
                  color="black"
                  class="col-md-6"
                ></v-radio>

                <v-radio
                  label=" Failed Rb Final Payments"
                  value="true"
                  color="black"
                  class="col-md-6"
                ></v-radio>
              </div>
            </div>
          </v-radio-group> -->
        </v-flex>
      </v-layout>
    </v-card-title>

    <FilterBoard
      class="accounts-advance-filter-panel oms-list-filter"
      title="Assignment payment queue"
      eyebrow=""
    >
        <v-flex xs3 class="oms-filter-board__field">
          <v-autocomplete
            v-model="searchTypes"
            :items="searchItems"
            label="Search Type"
            item-text="status"
            single-line
            persistent-hint
            item-value="abbr"
            @change="searchData()"
            return-object
          ></v-autocomplete>
        </v-flex>
        <v-divider class="divider-style" vertical></v-divider>
        <v-flex xs4 pr-3 class="oms-filter-board__field oms-filter-board__field--search">
          <v-text-field
            class="gap searchAccounts"
            :disabled="!searchTypes"
            :label="'Search here'"
            single-line
            v-model="search"
            append-icon="search"
            @keyup.enter="searchData()"
            @click:append="searchData()"
          ></v-text-field>
        </v-flex>

        <v-flex xs3 class="oms-filter-board__field">
          <v-autocomplete
            v-model="driverSearchTypes"
            :items="driverSearchItems"
            label="Search Type"
            item-text="status"
            single-line
            item-value="abbr"
            @change="searchData()"
            return-object
          ></v-autocomplete>
        </v-flex>
        <v-divider class="divider-style" vertical></v-divider>
        <v-flex xs4 pr-3 class="oms-filter-board__field oms-filter-board__field--search">
          <v-text-field
            class="gap searchAccounts"
            :label="'Search here'"
            :disabled="!driverSearchTypes"
            single-line
            v-model="driverSearch"
            append-icon="search"
            @keyup.enter="searchData()"
            @click:append="searchData()"
          ></v-text-field>
        </v-flex>
        <v-flex xs3 pt-3 pr-3 class="oms-filter-board__field">
          <v-autocomplete
            label="Truck Type"
            :items="subTruck"
            class="pt-0 currencyTitle"
            v-model="subTruckType"
            @change="searchData()"
            item-text="text"
            item-value="value"
            single-line
          />
        </v-flex>
        <v-flex xs3 pt-3 pr-3 class="oms-filter-board__field">
          <v-autocomplete
            class="pt-0 currencyTitle"
            :items="advanceStatusList"
            v-model="advanceStatus"
            label="Advance Status"
            single-line
            autocomplete="offfadsf"
            @change="searchData()"
          />
        </v-flex>
        <v-flex xs4 pt-3 pr-3 class="oms-filter-board__field">
          <v-autocomplete
            class="pt-0 currencyTitle"
            :items="statusList"
            v-model="assignStatus"
            label="Assign. Status"
            single-line
            autocomplete="offfadsf"
            @change="searchData()"
          />
        </v-flex>

        <v-flex
          xs4
          pt-3
          pr-3
          id="jobDate"
          class="wrapper date_9 oms-filter-board__field oms-filter-board__field--date"
        >
          <ejs-daterangepicker
            :placeholder="waterMark"
            v-model="dateRange2"
          ></ejs-daterangepicker>
        </v-flex>

        <v-flex class="oms-filter-board__actions">
          <v-card-actions class="justify-end">
            <v-btn
              class="reset-btn-color oms-filter-board__reset"
              flat
              prepend-icon
              color="orange darken-1"
              @click.native="reset()"
            >
              Reset
              <v-icon color="orange">donut_large</v-icon>
            </v-btn>
          </v-card-actions>
        </v-flex>
    </FilterBoard>

    <v-card-text class="pt-0 nospace accounts-advance-table-card">
      <ScrollableTable
        class="accounts-advance-table-scroll oms-list-table-scroll"
        min-width="100%"
      >
        <v-data-table
          id="jobsTable"
          class="accounts-advance-table oms-list-table"
          hide-actions
          :headers="modeAwareHeaders"
          item-key="_id"
          :disable-initial-sort="true"
          :pagination.sync="pagination"
          :items="items"
          @click.native="handleAssignmentRowClick"
        >
        <template slot="items" slot-scope="props">
          <td
            class="accounts-payment-summary-cell accounts-payment-job-cell"
            :data-assignment-id="props.item._id"
          >
            <v-layout row>
              <button
                type="button"
                class="accounts-payment-expand-toggle"
                :aria-expanded="isAssignmentExpanded(props.item._id)"
                @click="toggleAssignmentDetails(props.item._id)"
              >
                <v-icon small>{{
                  isAssignmentExpanded(props.item._id)
                    ? "keyboard_arrow_down"
                    : "keyboard_arrow_right"
                }}</v-icon>
              </button>
              <v-checkbox
                v-if="showCheckbox && items.length"
                v-model="props.item.selected"
                :disabled="
                  checkDataForSIGeneration(
                    props.item.isPurchaseInvoiceGenerated,
                    props.item.invoicePdfUrl,
                    props.item.assignmentStatus,

                    props.item.paymentAmount,
                    props.item.totalAdditionalAmount,
                    props.item.totalAdvancePaidAmount,
                    props.item.amountPaidToDriver,
                    props.item.workingCountry,
                    props.item.isEntryFailedForFinalPayments
                  )
                "
                @change="
                  checkSelected(props.item.selected, props.item._id, $event)
                "
              >
              </v-checkbox>
              <activityLogs
                :type="'assignment'"
                :permissions="'activity-logs-for-accounts'"
                :_id="props.item._id"
                :id="props.item.assignmentId.toString()"
              />

              <span style="padding-top: 4px !important; padding-left: 3px">
                {{ props.item.jobId }}
              </span></v-layout
            >
            {{ getTime3(props.item.pickupDate) }}
            {{ props.item.pickupTime }}
          </td>
          <td
            v-if="props.item.isEntryFailedForFinalPayments"
            class="accounts-payment-summary-cell accounts-payment-assignment-cell"
          >
            <span
              style="color: blue"
              v-if="props.item.assignmentType == 'Value Added Service'"
            >
              {{ props.item.assignmentId }}</span
            >
            <span v-else> {{ props.item.assignmentId }}</span
            ><br />
            <div
              class="red-text2 accounts-advance-status-text accounts-advance-status-text--failed"
            >
              ({{ assignmentStatus(props.item.assignmentStatus) || "-" }})
            </div>
          </td>
          <td
            v-else
            class="accounts-payment-summary-cell accounts-payment-assignment-cell"
          >
            <span
              style="color: blue"
              v-if="props.item.assignmentType == 'Value Added Service'"
            >
              {{ props.item.assignmentId }}</span
            >
            <span v-else> {{ props.item.assignmentId }}</span
            ><br /><span class="accounts-advance-status-text"
              >({{ assignmentStatus(props.item.assignmentStatus) || "-" }})</span
            >
          </td>
          <td
            class="accounts-advance-customer-details-cell accounts-payment-summary-cell accounts-payment-customer-cell"
          >
            <span class="accounts-advance-customer-details-text">
              {{ props.item.companyName || "N.A" }}
              <br />{{
                props.item.customerPhoneNumber
                  ? props.item.customerPhoneNumber
                  : ""
              }}
            </span>
            <CustomerDetailPopUp
              class="accounts-advance-customer-details-action"
              :detail="props.item"
            />
          </td>
          <td class="accounts-payment-summary-cell accounts-payment-driver-cell">
            <v-icon small>{{ getModeIcon(props.item.jobType) }}</v-icon>
            <span v-if="props.item.driverData">
              {{
                props.item.driverData.firstName +
                " " +
                props.item.driverData.lastName
              }}<br />{{
                props.item.driverData.countryCode +
                "-" +
                props.item.driverData.phoneNo
              }}</span
            >
            <span v-else>N.A</span>
            <ViewDetails
              v-if="props.item.driverData"
              :detail="props.item.driverData"
              :headers="driverDetailHeaders"
              :title="getOperatorRoleLabel(props.item.jobType)"
            />
          </td>
          <td
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-transporter-cell"
            data-detail-label="Transporter"
          >
            <div v-if="props.item.transporterData">
              {{ props.item.transporterData.transporterName || "-" }}<br />{{
                props.item.transporterData.countryCode +
                "-" +
                props.item.transporterData.phoneNo
              }}
            </div>
            <div v-else>N.A</div>
            <ViewDetails
              v-if="props.item.transporterData"
              :detail="props.item.transporterData"
              :headers="transporterDetailHeaders"
              :title="'Transporter'"
            />
            <v-flex> </v-flex>
          </td>
          <td class="accounts-payment-summary-cell accounts-payment-truck-cell">
            <v-flex v-if="props.item.driverData">
              <v-tooltip
                right
                class="milestone"
                content-class="tooltip-op"
                color="orange"
              >
                <template slot="activator" v-if="props.item.truckNumber">
                  {{ props.item.truckPrefix }}-{{
                    props.item.truckNumber
                  }}</template
                >
                <template slot="activator" v-else>
                  {{ props.item.driverData.truckPrefix }}-{{
                    props.item.driverData.truckNumber
                  }}</template
                >
                <span class="tooltip" v-if="props.item.jobType === '1'"
                  >{{ getText(subTruck, props.item.truckType) }}
                </span>
                <span class="tooltip" v-if="props.item.jobType === '2'">
                  {{ getText(airTypes, props.item.truckType.toString()) }}</span
                >
                <span class="tooltip" v-if="props.item.jobType === '3'">
                  {{ getText(seaTypes, props.item.truckType.toString()) }}</span
                >
              </v-tooltip>
            </v-flex>
            <v-flex v-else> N.A </v-flex>
          </td>
          <td class="accounts-payment-summary-cell accounts-payment-duty-cell">
            {{ parseFloat(props.item.perAssignmentPrice).toFixed(2) }}
            {{ props.item.customerCurrency }}
          </td>
          <td
            v-if="props.item.paymentAmount"
            class="accounts-payment-summary-cell accounts-payment-driver-price-cell"
          >
            {{ parseFloat(props.item.paymentAmount).toFixed(2) }}
            {{ props.item.customerCurrency }}
            <confirmationPopup
              v-if="props.item.assignmentStatus == 8"
              v-permissions="'approve-reject-driver-price'"
              :message="`Are you sure you want to approve the higher ${getOperatorRoleLabel(props.item.jobType).toLowerCase()} price (${props.item.paymentAmount} ${props.item.customerCurrency}) than the customer price (${props.item.perAssignmentPrice} ${props.item.customerCurrency}) for assignment ID ${props.item.assignmentId}?`"
              :confirmationTitle="`Approve ${getOperatorPriceLabel(props.item.jobType)} For Assignment ID ${props.item.assignmentId}`"
              :cancelBtn="'Cancel'"
              :confirmBtn="'Approve'"
              :customerData="props.item"
              :type="'driverApprove'"
              :assignmentId="props.item.assignmentId"
              @refresh-list="refresh()"
            />
            <CancellationPopup
              v-if="props.item.assignmentStatus == 8"
              v-permissions="'approve-reject-driver-price'"
              :message="`Are you sure you want to reject the higher ${getOperatorRoleLabel(props.item.jobType).toLowerCase()} price for this assignment?`"
              :confirmationTitle="`Reject ${getOperatorPriceLabel(props.item.jobType)} For Assignment ID ${props.item.assignmentId}`"
              :cancelBtn="'Cancel'"
              :type="'driverApprove'"
              :assignmentId="props.item.assignmentId"
              :confirmBtn="'Reject'"
              :customerData="props.item"
              @refresh-list="refresh()"
            />
          </td>
          <td
            v-else
            class="accounts-payment-summary-cell accounts-payment-driver-price-cell"
          >N.A</td>
          <td
            v-if="props.item.invoiceAmount"
            class="accounts-payment-summary-cell accounts-payment-invoice-cell"
          >
            {{ props.item.invoiceAmount.toFixed(2) }}
            {{ props.item.customerCurrency }}
          </td>
          <td
            v-else
            class="accounts-payment-summary-cell accounts-payment-invoice-cell"
          >N.A</td>
          <td
            v-if="props.item.jobData.isJobActivatedByScript"
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-advance-requested-cell"
            data-detail-label="Advance Requested"
          >N.A</td>
          <td
            v-else
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-advance-requested-cell"
            data-detail-label="Advance Requested"
          >
            <v-layout justify-center>
              <activityLogs
                class="pd_5"
                :permissions="'activity-logs-for-accounts'"
                :type="'jobs'"
                v-if="
                  props.item.everAdvanceGenerated || props.item.advanceAmount
                "
                :subType="5"
                :assignmentId="props.item._id"
                :_id="props.item.jobData._id"
                :whichId="'Assignment'"
                :id="props.item.assignmentId.toString()"
                :section="'advance'"
              />

              <span class="pd-t-l" v-if="props.item.advanceAmount"
                >{{ props.item.advanceAmount }}
                {{ props.item.customerCurrency }}</span
              >
            </v-layout>

            <AdvanceReadyToPay
              v-if="props.item.assignmentStatus > 1"
              :section="'Accounts'"
              :assignId="props.item._id"
              :totalAdvanceAmountPaid="props.item.totalAdvancePaidAmount"
              :additionalCharges="props.item.totalAdditionalAmount"
              :jobCurrency="props.item.customerCurrency"
              @assignment-list-refresh="refresh()"
            />
            <span
              v-if="
                props.item.assignmentStatus <= 1 && !props.item.advanceAmount
              "
              >N.A.</span
            >
          </td>
          <td
            v-if="props.item.jobData.isJobActivatedByScript"
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-advance-paid-cell"
            data-detail-label="Advance Paid"
          >N.A</td>
          <td
            v-else
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-advance-paid-cell"
            data-detail-label="Advance Paid"
          >
            <span v-if="props.item.totalAdvancePaidAmount"
              >{{ props.item.totalAdvancePaidAmount }}
              {{ props.item.customerCurrency }}</span
            >
            <span v-else>N.A</span>
          </td>
          <td
            v-if="props.item.jobData.isJobActivatedByScript"
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-additional-cell"
            data-detail-label="Additional Charges"
          >N.A</td>
          <td
            v-else
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-additional-cell"
            data-detail-label="Additional Charges"
          >
            <span v-if="props.item.totalMiscellaneousChargeAmount">
              Misc:&nbsp;{{ props.item.totalMiscellaneousChargeAmount }}
              {{ props.item.customerCurrency }}</span
            >
            <br v-if="props.item.totalAdditionalAmount" />
            <span v-if="props.item.totalAdditionalAmount"
              >{{ getOperatorRoleLabel(props.item.jobType) }}:&nbsp;
              {{ props.item.totalAdditionalAmount }}
              {{ props.item.customerCurrency }}</span
            ><br v-if="props.item.totalCostMarginAdditionalAmount" />
            <span v-if="props.item.totalCostMarginAdditionalAmount">
              Customer:&nbsp;{{ props.item.totalCostMarginAdditionalAmount }}
              {{ props.item.customerCurrency }}</span
            >

            <additionalChargesPopup
              v-if="props.item.assignmentStatus > 1"
              :isAssign="props.item._id"
              :isCustomerReceiptInitiated="
                props.item.isCustomerReceiptInitiated
              "
              :jobCurrency="props.item.customerCurrency"
              :amountPaidToDriver="props.item.amountPaidToDriver"
              :jobSalesInvoice="props.item.jobData.isSalesInvoiceGenerated"
              :assignSalesInvoice="props.item.isSalesInvoiceGenerated"
            />
            <span
              v-if="
                props.item.assignmentStatus <= 1 &&
                !props.item.totalAdditionalAmount
              "
              >N.A</span
            >
          </td>
          <td
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-final-cell"
            data-detail-label="Final Payment"
          >
            <v-layout justify-center>
              <v-flex xs4 v-if="props.item.isReadyForFinalPayment">
                <activityLogs
                  v-if="props.item.isReadyForFinalPayment"
                  class="pd_5 pr-2"
                  :permissions="'activity-logs-for-accounts'"
                  :type="'assignment'"
                  :subType="7"
                  :assignmentId="props.item._id"
                  :_id="props.item.jobData._id"
                  :whichId="'Assignment'"
                  :id="props.item.assignmentId.toString()"
                  :section="'advance'"
                />
              </v-flex>

              <span v-if="!props.item.isReadyForFinalPayment"> N.A </span>
              <span
                v-else-if="
                  !props.item.isPurchaseInvoiceGenerated &&
                  props.item.assignmentStatus != 7 &&
                  props.item.workingCountry !== 'PAK' &&
                  props.item.workingCountry !== 'OMAN'
                "
              >
                <v-tooltip
                  top
                  class="milestone"
                  content-class="tooltip-op"
                  color="grey"
                >
                  <template slot="activator">
                    <button
                      v-if="
                        props.item.paymentAmount +
                          props.item.totalAdditionalAmount -
                          props.item.totalAdvancePaidAmount -
                          props.item.amountPaidToDriver <
                        0
                      "
                      type="button"
                      color="orange"
                      outline
                      class="pay-ass-btn grey-button"
                      disabled
                    >
                      Adjust
                    </button>
                    <button
                      v-if="
                        props.item.paymentAmount +
                          props.item.totalAdditionalAmount -
                          props.item.totalAdvancePaidAmount -
                          props.item.amountPaidToDriver >
                        0
                      "
                      type="button"
                      color="orange"
                      outline
                      class="pay-ass-btn grey-button pl-2"
                      disabled
                    >
                      {{
                        props.item.ownerType == "Transporter"
                          ? "Pay Transporter"
                          : `Pay ${getOperatorRoleLabel(props.item.jobType)}`
                      }}
                    </button></template
                  >
                  <span class="tooltip"
                    >Generate Purchase Invoice to pay
                    {{ getOperatorRoleLabel(props.item.jobType).toLowerCase() }} balance</span
                  >
                </v-tooltip></span
              >
              <span
                v-else-if="
                  props.item.totalReadyToPayAmount != 0 &&
                  props.item.workingCountry == 'PAK' &&
                  props.item.assignmentStatus != 7
                "
              >
                <v-tooltip
                  top
                  class="milestone"
                  content-class="tooltip-op"
                  color="grey"
                >
                  <template slot="activator">
                    <button
                      type="button"
                      color="orange"
                      outline
                      class="pay-ass-btn grey-button pl-2"
                      disabled
                    >
                      {{
                        props.item.ownerType == "Transporter"
                          ? "Pay Transporter"
                          : "Pay Driver"
                      }}
                    </button></template
                  >
                  <span class="tooltip">Please clear all advance.</span>
                </v-tooltip></span
              >
              <span
                v-else-if="
                  props.item.totalReadyToPayAmount != 0 &&
                  props.item.workingCountry == 'OMAN' &&
                  props.item.assignmentStatus != 7
                "
              >
                <v-tooltip
                  top
                  class="milestone"
                  content-class="tooltip-op"
                  color="grey"
                >
                  <template slot="activator">
                    <button
                      type="button"
                      color="orange"
                      outline
                      class="pay-ass-btn grey-button pl-2"
                      disabled
                    >
                      {{
                        props.item.ownerType == "Transporter"
                          ? "Pay Transporter"
                          : "Pay Driver"
                      }}
                    </button></template
                  >
                  <span class="tooltip">Please clear all advance.</span>
                </v-tooltip></span
              >
              <span
                class="pd_8"
                v-else-if="
                  !props.item.isPurchaseInvoiceGenerated &&
                  props.item.workingCountry === 'PAK' &&
                  props.item.assignmentStatus >= 2 &&
                  props.item.assignmentStatus != -1 &&
                  props.item.assignmentStatus != 4 &&
                  props.item.assignmentStatus != 7
                "
              >
                {{ getAdvanceAmount(props.item) }}</span
              >
              <span
                class="pd_8"
                v-else-if="
                  !props.item.isPurchaseInvoiceGenerated &&
                  props.item.workingCountry === 'OMAN' &&
                  props.item.assignmentStatus >= 2 &&
                  props.item.assignmentStatus != -1 &&
                  props.item.assignmentStatus != 4 &&
                  props.item.assignmentStatus != 7
                "
              >
                {{ getAdvanceAmount(props.item) }}</span
              >
              <span
                class="pd_8"
                v-else-if="
                  props.item.isPurchaseInvoiceGenerated &&
                  props.item.assignmentStatus >= 2 &&
                  props.item.assignmentStatus != -1 &&
                  props.item.assignmentStatus != 7 &&
                  props.item.assignmentStatus != 4
                "
              >
                {{ getAdvanceAmount(props.item) }}
              </span>
            </v-layout>

            <v-layout class="pb-1 pt-1" align-center justify-center>
              <DocApproval
                v-if="props.item.assignmentStatus == 7"
                :details="props.item"
                @refresh-list="refresh()"
              />
              <PaymentDone
                :section="'Accounts'"
                :confirmationTitle="'Comments'"
                :details="props.item"
                :cancelBtn="'Cancel'"
                @close="error = 'Kindly collect the gps device'"
                :assignId="props.item._id"
                :PendingAmount="getPendingAmountForProps(props.item)"
                :confirmBtn="'Pay'"
                @refresh-list="refresh()"
              />
              <PendingAmount
                v-if="!props.item.isEntryFailedForFinalPayments"
                @payment-list-refresh="refresh()"
                :invoiceCity="props.item.invoicingCity"
                :invoiceCompany="props.item.invoicingCountry"
                :PendingAmount="getPendingAmountForProps(props.item)"
                :driverCreditDuration="
                  props.item.driverData
                    ? props.item.driverData.driverPaymentDuration
                    : null
                "
                v-permissions="'pending-amount-for-driver-for-accounts'"
                :priceData="props.item"
              />
              <PendingAmountList
                v-if="props.item.isEntryFailedForFinalPayments"
                :type="'rbFailed'"
                :assignId="props.item._id"
                :currency="props.item.customerCurrency"
                :priceData="props.item"
                :PendingAmount="getPendingAmountForProps(props.item)"
                @assignment-list-refresh="refresh()"
              />
            </v-layout>
            <v-layout class="pb-1" align-center justify-center>
              <!-- <PendingAmountList
                v-if="props.item.amountPaidToDriver"
                :type="'Finance'"
                :assignId="props.item._id"
                :currency="props.item.customerCurrency"
                @assignment-list-refresh="refresh()"
              /> -->
            </v-layout>
            <v-layout class="pb-1 pt-1" align-center justify-center>
              <button
                v-if="props.item.isReadyForFinalPayment"
                class="blue-button"
                flat
                prepend-icon
                color="white darken-1"
                @click.stop="goToProof(props.item._id)"
              >
                View Docs
              </button>
              <div
                v-if="
                  (props.item.assignmentStatus == 3 &&
                    props.item.amountPaidToDriver > 0) ||
                  (props.item.assignmentStatus == 4 &&
                    props.item.amountPaidToDriver > 0)
                "
                class="padding-left:5px !important"
              >
                <PendingAmountList
                  v-if="
                    props.item.assignmentStatus == 3 &&
                    !props.item.isEntryFailedForFinalPayments
                  "
                  :type="'Finance'"
                  :assignId="props.item._id"
                  :currency="props.item.customerCurrency"
                  :priceData="props.item"
                  :PendingAmount="getPendingAmountForProps(props.item)"
                  @assignment-list-refresh="refresh()"
                />
                <PendingAmountList
                  v-if="props.item.assignmentStatus == 4"
                  :type="'Finance'"
                  :assignId="props.item._id"
                  :currency="props.item.customerCurrency"
                  :priceData="props.item"
                  :PendingAmount="getPendingAmountForProps(props.item)"
                  @assignment-list-refresh="refresh()"
                />
              </div>
            </v-layout>
          </td>

          <td
            v-if="
              props.item.workingCountry == 'PAK' ||
              props.item.workingCountry == 'OMAN'
            "
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-purchase-cell"
            data-detail-label="Purchase Invoice"
          >
            -
          </td>
          <td
            v-else
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-purchase-cell"
            data-detail-label="Purchase Invoice"
          >
            <v-flex v-if="!props.item.workingCountry">-</v-flex>

            <v-flex
              v-else-if="
                !props.item.isPurchaseInvoiceGenerated &&
                !props.item.invoiceNumber &&
                !props.item.isReadyToGeneratePurchaseInvoice &&
                props.item.workingCountry != 'PAK' &&
                props.item.workingCountry != 'OMAN'
              "
            >
              <v-tooltip
                top
                class="milestone"
                content-class="tooltip-op"
                color="grey"
              >
                <template slot="activator">
                  <button
                    class="account-disabled-ass-btn"
                    flat
                    prepend-icon
                    type="button"
                    v-permissions="'generate-downaload-po-pi-for-accounts'"
                    color="grey"
                    disabled
                  >
                    Generate PI
                  </button></template
                >
                <span v-if="!props.item.voucherIdRealBooks" class="tooltip"
                  >Generate PO to generate Purchase invoice.</span
                >
                <span v-if="props.item.voucherIdRealBooks" class="tooltip"
                  >Complete shipment to generate Purchase invoice.</span
                >
              </v-tooltip>
            </v-flex>

            <!--
             <v-flex v-else-if="props.item.workingCountry=='UAE'">
              <v-tooltip
                top
                class="milestone"
                content-class="tooltip-op"
                color="grey"
              >
                <template slot="activator">
                  <button
                    class="assign--disable-ass-btn"
                    flat
                    prepend-icon
                    type="button"
                    v-permissions="'generate-downaload-po-pi-for-accounts'"
                    color="grey"
                    disabled
                  >
                    <v-icon style="color: lightgray; !important" small
                      >settings</v-icon
                    >PI
                  </button></template
                >
                <span class="tooltip"
                  >Generate PO to generate purchase invoice.</span
                >
              </v-tooltip></v-flex
            >
   
           <v-flex
              v-else-if="
                !props.item.isPurchaseInvoiceGenerated &&
                !props.item.invoiceNumber &&
                !props.item.isReadyToGeneratePurchaseInvoice &&
                !props.item.invoicePdfUrl &&
                props.item.VendorWorkingCountry != 'PAK'
              "
            >
              <v-tooltip
                top
                class="milestone"
                content-class="tooltip-op"
                color="grey"
              >
                <template slot="activator">
                  <button
                    class="assign--disable-ass-btn"
                    flat
                    prepend-icon
                    type="button"
                    v-permissions="'generate-downaload-po-pi-for-accounts'"
                    color="grey"
                    disabled
                  >
                    <v-icon style="color: lightgray; !important" small
                      >settings</v-icon
                    >PI
                  </button></template
                >
                <span v-if="!props.item.voucherIdRealBooks" class="tooltip"
                  >Generate SO to generate sales invoice.</span
                >
                <span v-if="props.item.voucherIdRealBooks" class="tooltip"
                  >Complete shipment to generate sales invoice.</span
                >
              </v-tooltip>
            </v-flex> -->

            <v-flex
              v-if="
                props.item.isReadyToGeneratePurchaseInvoice &&
                !props.item.isPurchaseInvoiceGenerated &&
                !props.item.isPurchaseOrderInQueue &&
                props.item.WorkingCountry != 'PAK' &&
                props.item.WorkingCountry != 'OMAN'
              "
            >
              <div>
                <div v-if="props.item.showPurchaseInvoiceButton">
                  <button
                    @click="
                      openPiGenerate(props.item.assignmentId, props.item._id)
                    "
                    v-permissions="'generate-downaload-po-pi-for-accounts'"
                    target="_blank"
                    v-if="!props.item.isPurchaseInvoviceBackgroundProcess"
                    class="assign-ass-btn"
                    title="Generate"
                  >
                    Generate PI
                  </button>

                  <div
                    v-if="props.item.isPurchaseInvoviceBackgroundProcess"
                    style="word-break: break-word"
                  >
                    Purchase Invoice can't be generated, Background process is
                    ongoing.
                  </div>
                </div>
                <div v-else>
                  <div>
                    <v-tooltip
                      top
                      class="milestone"
                      content-class="tooltip-op"
                      color="grey"
                    >
                      <template slot="activator">
                        <button
                          class="account-disabled-ass-btn"
                          flat
                          prepend-icon
                          type="button"
                          v-permissions="
                            'generate-downaload-po-pi-for-accounts'
                          "
                          color="grey"
                          disabled
                        >
                          Generate PI
                        </button></template
                      >
                      <span class="tooltip">Please clear all advance</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </v-flex>
            <div v-if="props.item.invoiceNumber == 'NA'">N.A</div>
            <div v-else>
              <v-flex
                v-if="
                  props.item.invoiceNumber &&
                  props.item.isPurchaseInvoiceGenerated &&
                  props.item.WorkingCountry != 'PAK' &&
                  (props.item.assignmentStatus != 1 ||
                    props.item.assignmentStatus != -1)
                "
              >
                <div v-if="props.item.WorkingCountry != 'PAK'">
                  {{ props.item.invoiceNumber }}
                </div>
              </v-flex>

              <v-flex
                v-if="
                  props.item.invoicePdfUrl &&
                  props.item.isPurchaseInvoiceGenerated &&
                  props.item.WorkingCountry != 'PAK' &&
                  props.item.WorkingCountry != 'OMAN'
                "
              >
                <div class="accounts-invoice-actions">
                  <button
                    v-if="props.item.isPurchaseInvoiceDownloadAllowed"
                    v-permissions="'generate-downaload-po-pi-for-accounts'"
                    class="download-ass-btn"
                    flat
                    type="button"
                    prepend-icon
                    :loading="loading"
                    :disabled="loading"
                    title="Download Invoice"
                    color="orange"
                    @click="
                      checkViewInvoice(
                        props.item.invoicePdfUrl,
                        props.item.isDownloadInvocie,
                        props.item.isPurchaseInvoviceBackgroundProcess,
                        props.item.invoiceNumber
                      )
                    "
                  >
                    <v-icon small color="white">download</v-icon>
                  </button>
                  <button
                    v-if="props.item.isPurchaseInvoiceDownloadAllowed"
                    class="download-ass-btn"
                    flat
                    type="button"
                    v-permissions="'pi-download-control'"
                    prepend-icon
                    :loading="loading"
                    :disabled="loading"
                    title="hide"
                    color="orange"
                    @click="hideUnhidePI(false, props.item._id)"
                  >
                    Hide
                  </button>
                  <button
                    v-if="!props.item.isPurchaseInvoiceDownloadAllowed"
                    v-permissions="'pi-download-control'"
                    class="download-ass-btn"
                    flat
                    type="button"
                    prepend-icon
                    :loading="loading"
                    :disabled="loading"
                    title="hide"
                    color="orange"
                    @click="hideUnhidePI(true, props.item._id)"
                  >
                    Unhide
                  </button>
                </div>
              </v-flex>
              <div
                v-if="
                  props.item.WorkingCountry != 'PAK' &&
                  props.item.WorkingCountry != 'OMAN' &&
                  !props.item.isPurchaseInvoiceGenerated &&
                  props.item.assignmentStatus != -1
                "
                class="pt-1 accounts-invoice-actions"
              >
                <button
                  v-if="props.item.isPurchaseInvoiceDownloadAllowed"
                  class="download-ass-btn"
                  flat
                  type="button"
                  v-permissions="'pi-download-control'"
                  prepend-icon
                  :loading="loading"
                  :disabled="loading"
                  title="HIDE PI"
                  color="orange"
                  @click="hideUnhidePI(false, props.item._id)"
                >
                  Hide
                </button>
                <button
                  v-if="!props.item.isPurchaseInvoiceDownloadAllowed"
                  v-permissions="'pi-download-control'"
                  class="download-ass-btn"
                  flat
                  type="button"
                  prepend-icon
                  :loading="loading"
                  :disabled="loading"
                  title="UNHIDE PI"
                  color="orange"
                  @click="hideUnhidePI(true, props.item._id)"
                >
                  Unhide
                </button>
              </div>
            </div>
          </td>
          <td
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-download-docs-cell"
            data-detail-label="Download Documents"
          >
            <AllDocuments :detail="props.item" />
          </td>
          <td
            v-if="
              props.item.workingCountry == 'PAK' ||
              props.item.workingCountry == 'OMAN'
            "
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-sales-cell"
            data-detail-label="Sales Invoice"
          >
            -
          </td>

          <td
            v-else
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-sales-cell"
            data-detail-label="Sales Invoice"
          >
            <v-flex v-if="props.item.workingCountry == 'PAK'">-</v-flex>
            <v-flex v-else-if="!props.item.isPurchaseInvoiceGenerated">
              <v-tooltip
                top
                class="milestone"
                content-class="tooltip-op"
                color="grey"
              >
                <template slot="activator">
                  <button
                    class="account-disabled-ass-btn"
                    flat
                    prepend-icon
                    type="button"
                    color="grey"
                    disabled
                  >
                    Generate SI
                  </button></template
                >
                <span class="tooltip"
                  >Complete Purchase invoice to generate Sales invoice.</span
                >

                <!-- <span v-if="props.item.jobData.isSalesInvoiceGenerated" class="tooltip"
                  >Job level  Sales Invoice  already  generated.</span
                >
                <span v-if="!props.item.isPurchaseInvoiceGenerated" class="tooltip"
                  >Complete shipment to generate sales invoice.</span
                > -->
              </v-tooltip></v-flex
            >

            <v-flex v-else-if="props.item.jobData.isSalesInvoiceGenerated">
              <div v-if="props.item.jobData.invoiceNumber == 'NA'">N.A</div>
              <div v-else>
                <v-flex
                  v-if="
                    props.item.jobData.invoiceNumber &&
                    props.item.jobData.isSalesInvoiceGenerated &&
                    props.item.workingCountry != 'PAK'
                  "
                >
                  {{ props.item.jobData.invoiceNumber }}
                </v-flex>
                <v-flex
                  v-if="
                    props.item.jobData.invoicePdfUrl &&
                    props.item.jobData.isSalesInvoiceGenerated &&
                    props.item.workingCountry != 'PAK'
                  "
                >
                  <v-layout class="accounts-invoice-actions" style="text-align: center">
                    <v-flex style="text-align: end">
                      <button
                        class="download-ass-btn"
                        v-permissions="'generate-downaload-so-si-for-accounts'"
                        type="button"
                        color="orange"
                        title="Download Invoice"
                        :disabled="loading"
                        outline
                        @click="openDownloadAdvance(props.item, 'job', $event)"
                      >
                        <v-icon color="white" small>download</v-icon>
                      </button>
                    </v-flex>
                    <v-flex style="text-align: start; padding-left: 3px">
                      <SendSI
                        :jobId="props.item.jobId"
                        :email="props.item.userData.email"
                        :invoiceUrl="props.item.salesInvoicePdfUrl"
                        :workingCountry="props.item.workingCountry"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </div>
            </v-flex>

            <v-flex
              v-if="
                !props.item.isSalesInvoiceGenerated &&
                !props.item.jobData.isSalesInvoiceGenerated &&
                props.item.isPurchaseInvoiceGenerated &&
                props.item.workingCountry != 'PAK' &&
                !props.item.isSaleOrderInQueue
              "
            >
              <!-- <div class="subheading muted">Generate Sales Invoice</div>
              <div class="heading"> -->
              <button
                v-permissions="'generate-downaload-so-si-for-accounts'"
                @click="
                  openSiPopup(props.item.userData, props.item._id, props.item)
                "
                type="button"
                v-if="!props.item.isSaleInvoviceBackgroundProcess"
                class="account-ass-btn"
                :disabled="loading"
                color="orange"
                outline
              >
                Generate SI
              </button>

              <!-- </div> -->
            </v-flex>
            <div
              v-if="
                props.item.isSaleInvoviceBackgroundProcess &&
                !props.item.jobData.isSalesInvoiceGenerated
              "
              style="word-break: break-word"
            >
              Background process is ongoing.
            </div>

            <v-flex
              v-if="
                props.item.salesInvoiceNumber &&
                props.item.isSalesInvoiceGenerated &&
                !props.item.jobData.isSalesInvoiceGenerated &&
                props.item.workingCountry != 'PAK'
              "
            >
              {{ props.item.salesInvoiceNumber }}
            </v-flex>
            <v-flex
              v-if="
                props.item.salesInvoicePdfUrl &&
                props.item.isSalesInvoiceGenerated &&
                !props.item.jobData.isSalesInvoiceGenerated &&
                props.item.workingCountry != 'PAK'
              "
            >
              <v-layout class="accounts-invoice-actions" style="text-align: center">
                <v-flex style="text-align: end">
                  <button
                    class="download-ass-btn"
                    v-permissions="'generate-downaload-so-si-for-accounts'"
                    type="button"
                    color="orange"
                    title="Download Invoice"
                    :disabled="loading"
                    outline
                    @click="
                      openDownloadAdvance(props.item, 'assignment', $event)
                    "
                  >
                    <v-icon color="white" small>download</v-icon>
                  </button>
                </v-flex>
                <v-flex style="text-align: start; padding-left: 3px">
                  <SendSI
                    :jobId="props.item.jobId"
                    :email="props.item.userData.email"
                    :invoiceUrl="props.item.salesInvoicePdfUrl"
                    :workingCountry="props.item.workingCountry"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </td>
          <td
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-credit-cell"
            data-detail-label="Credit Days"
          >
            <span
              v-if="
                props.item.finalPaymentWithCreditDaysDriver &&
                props.item.assignmentStatus != 4
              "
              class="font_Bold"
            >
              <span
                v-if="getDays(props.item.finalPaymentWithCreditDaysDriver) > 5"
                class="orange-text"
              >
                {{ getDays(props.item.finalPaymentWithCreditDaysDriver) }}
              </span>
              <span v-else class="red-text">
                {{ getDays(props.item.finalPaymentWithCreditDaysDriver) }}
              </span>
            </span>
            <span v-else>-</span>
          </td>
          <td
            v-show="isAssignmentExpanded(props.item._id)"
            class="accounts-advance-comment-cell accounts-payment-detail-cell accounts-payment-detail-cell--expanded accounts-payment-comments-cell"
            data-detail-label="Internal Comments"
          >
            <div class="accounts-advance-comment-wrap">
              <div
                v-if="
                  props.item.LastCommentTime &&
                  props.item.LastCommentTime.comment &&
                  props.item.LastCommentTime.comment != ' '
                "
                class="accounts-advance-comment-text"
              >
                <v-tooltip
                  left
                  class="milestone"
                  content-class="tooltip-op-comment"
                  color="orange"
                >
                  <template slot="activator">
                    <span>
                      {{ props.item.LastCommentTime.comment }}
                    </span>
                  </template>
                  <span
                    class="tooltip"
                    style="word-break: break-all !important"
                    >{{ props.item.LastCommentTime.comment }}</span
                  >
                </v-tooltip>
              </div>
              <SendComments
                class="accounts-advance-comment-action"
                :userId="props.item.userId"
                :userName="props.item.customer"
                :detail="props.item"
                :type="3"
                :assignId="props.item._id"
                v-on:pagination-load="refreshOnComment"
                :section="'assignments'"
                :id="props.item.jobId"
              />
            </div>
          </td>

          <td class="accounts-payment-summary-cell accounts-payment-actions-cell">
            <AdvanceReadyToPay
              v-if="
                props.item.assignmentStatus > 1 &&
                props.item.assignmentStatus != 4
              "
              :section="'Pay'"
              :isVisible="props.item.totalReadyToPayAmount"
              :assignId="props.item._id"
              :advancePaid="props.item.totalAdvancePaidAmount"
              :additionalCharges="props.item.totalAdditionalAmount"
              :jobCurrency="props.item.customerCurrency"
              @assignment-list-refresh="refresh()"
            />
            <button
              @click="
                goToDoc(
                  props.item.jobId,
                  props.item.assignmentId,
                  props.item._id
                )
              "
              class="doc-ass-btn"
              outline
              color="orange"
              type="button"
            >
              Documents
            </button>
          </td>
        </template>
        </v-data-table>
      </ScrollableTable>
      <success-dialog
        :content="x.message"
        :show="x.success"
        :heading="x.heading"
        :onclose="closeMessage"
      />
      <pagination
        :totalPages="totalPages"
        :componentKey="componentKey"
        :pages="this.pages"
        @pageNo="page"
        :type="0"
        :url="paginationURL"
        :loading="loading"
        :callback="callback"
        :action="`advance`"
        v-on:pagination-load="checkLoading"
      />
      <v-snackbar
        :timeout="3000"
        bottom
        color="red darken-2"
        v-model="error"
        class="white--text"
        v-if="error"
        >{{ error }}</v-snackbar
      >

      <confirmation-dialog
        :content="`Are you sure to remove transporter from this assignment?`"
        :toShow="confirmationDialog.removeTransporterAssignment"
        :onClose="() => remove()"
        confirmTitle="Unassign"
        :loading="loading"
        :error="error"
        :onConfirm="() => removeTransporterAssignment(this.assignmentData)"
      />
      <confirmation-dialog
        :content="`Are you sure to remove ${
          this.assignmentData.driverData
            ? this.assignmentData.driverData.name
            : ''
        } from this assignment?`"
        :toShow="confirmationDialog.removeDriverAssignment"
        :onClose="removeDriver"
        confirmTitle="Unassign"
        :loading="loading"
        :error="error"
        :onConfirm="() => removeDriverAssignment(this.assignmentData)"
      />
    </v-card-text>
    <v-dialog
      v-model="invoiceDialog"
      persistent
      max-width="32rem"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar dark style="background-color: #fee9d0; color: black" flat>
          <v-toolbar-title>{{ headerVatPopup }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon
              class="heading grey--text text--darken-4"
              @click.prevent="invoiceDialog = false"
              :disabled="loading"
              >close</v-icon
            >
          </v-btn>
        </v-toolbar>
        <v-spacer class="spacerclass">
          <div style="text-align: center">
            <div class="pb-4">
              <img
                src="../../../assets/ConfirmationPi.svg"
                height="350"
                width="500"
                class="spMargin"
              />
            </div>
            <div>{{ messageVat }}</div>
          </div>

          <v-card-actions class="pt-2 pb-5" style="justify-content: center">
            <v-btn
              v-if="vatInfo"
              medium
              style="text-transform: none !important"
              color="red white--text "
              darken-1
              :disabled="loading"
              text
              @click="confirmationPiGenerate('Without VaT')"
              >No</v-btn
            >
            <v-btn
              v-if="!vatInfo"
              color="grey"
              @click="invoiceDialog = false"
              text
              >Cancel</v-btn
            >
            <v-btn
              v-if="!vatInfo"
              medium
              style="text-transform: none !important"
              color="green white--text "
              v-permissions="'generate-purchase-invoice'"
              darken-1
              @click="generateInvoiceNumber()"
              :disabled="loading"
              text
              >Yes</v-btn
            >
            <v-btn
              v-if="vatInfo"
              medium
              style="text-transform: none !important"
              color="green white--text "
              v-permissions="'generate-purchase-invoice'"
              darken-1
              @click="confirmationPiGenerate('With VaT')"
              :disabled="loading"
              text
              >Yes</v-btn
            >
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogRetry"
      persistent
      max-width="41rem"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar dark style="background-color: #f5f5f5; color: black" flat>
          <v-toolbar-title> {{ headingRetryPopup }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon
              class="heading grey--text text--darken-4"
              @click.prevent="dialogRetry = false"
              >close</v-icon
            >
          </v-btn>
        </v-toolbar>
        <v-spacer class="spacerclass">
          <v-card-text class="pa-4"> {{ messageRetryPopup }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              medium
              style="text-transform: none !important"
              darken-1
              :disabled="loading"
              text
              @click="dialogRetry = false"
              >Cancel</v-btn
            >
            <v-btn
              v-if="headingRetryPopup == 'Confirmation'"
              medium
              style="text-transform: none !important"
              color="orange white--text "
              darken-1
              @click="retryAllAdvanceOrFinalPayment('advance')"
              :disabled="loading"
              text
              >Yes,Pay</v-btn
            >
            <v-btn
              v-else
              medium
              style="text-transform: none !important"
              color="orange white--text "
              darken-1
              @click="retryAllAdvanceOrFinalPayment('final')"
              :disabled="loading"
              text
              >Yes</v-btn
            >
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogPi"
      persistent
      max-width="41rem"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar dark style="background-color: #fee9d0; color: black" flat>
          <v-toolbar-title> Final Confirmation</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon
              class="heading grey--text text--darken-4"
              @click.prevent="dialogPi = false"
              >close</v-icon
            >
          </v-btn>
        </v-toolbar>
        <v-spacer class="spacerclass">
          <v-card-text class="pa-4">
            {{ ConfirmMessageVat }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="vatInfo"
              medium
              style="text-transform: none !important"
              color="red white--text "
              darken-1
              :disabled="loading"
              text
              @click="dialogPi = false"
              >No</v-btn
            >
            <v-btn
              v-if="!FinalvatApply"
              medium
              style="text-transform: none !important"
              color="green white--text "
              v-permissions="'generate-purchase-invoice'"
              darken-1
              @click="generateInvoiceNumber('No'), (vatAmount = 0)"
              :disabled="loading"
              text
              >Yes</v-btn
            >

            <v-btn
              v-if="FinalvatApply"
              medium
              style="text-transform: none !important"
              color="green white--text "
              v-permissions="'generate-purchase-invoice'"
              darken-1
              @click="generateInvoiceNumber('Yes')"
              :disabled="loading"
              text
              >Yes</v-btn
            >
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>

    <CustomerAdvancePopup
      v-model="customerAdvanceDialog"
      :currency="customerAdvanceCurrency"
      :max-amount="customerAdvanceMax"
      :advance-type="customerAdvanceType"
      :advance-id="customerAdvanceId"
      :title="customerAdvanceCopy.title"
      :message="customerAdvanceCopy.message"
      :hint="customerAdvanceCopy.hint"
      :yes-text="customerAdvanceCopy.yesText"
      @confirm="onCustomerAdvanceConfirm"
      @cancel="onCustomerAdvanceCancel"
    />

    <GenerateInvoiceDialog
      :open="dialog1"
      v-model="bank"
      :banks="bankInfo"
      :loading="loading"
      @change="setCustomerValues"
      @cancel="closeBankInfo()"
      @confirm="generateInvoiceNumber2()"
    />
  </FinanceControlShell>
</template>

<script>
import Vue from "vue";
import { accountAdvanceSummaryList } from "@/constants/datatable-headers.js";
import FinanceControlShell from "@/components/Accounts/FinanceControlShell";
import FilterBoard from "@/components/Common/FilterBoard";
import ScrollableTable from "@/components/Common/ScrollableTable";
import SegmentedControl from "@/components/Common/SegmentedControl";
import moment from "moment";
import PendingAmount from "../Popups/PendingAmount.vue";
import DocApproval from "../Popups/DocApproval.vue";
import PaymentDone from "../Popups/PaymentDone.vue";
import EditPendingAmount from "../Popups/EditPendingAmount";
import ProofOfDelivery from "@/components/Pop-ups/ProofOfDelivery";
import SuccessDialog from "@/components/Common/SuccessDialog";
import { DateRangePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import SendSI from "../Popups/SendSI";
import AllDocuments from "../Popups/AllDocuments";
import confirmationPopup from "@/components/Pop-ups/confirmationPopup.vue";
import CancellationPopup from "@/components/Pop-ups/CancellationPopup.vue";

import AddProofDoc from "@/components/Pop-ups/AddProofDoc";
import Loading from "vue-loading-overlay";
import {
  StorageKeys,
  JobListTypes,
  TruckTypes,
  JobTypes,
  SeaTypes,
  AirTypes,
  TruckArray,
  AssignmentStatusList,
  AdvanceStatusaccountsList,
} from "@/constants/constants";
import activityLogs from "../../Common/activityLogs.vue";
import AssignmentInvoicePopup from "./AssignmentInvoicePopup";
import GenerateInvoiceDialog from "@/components/Common/GenerateInvoiceDialog";
import MultipleAssignmentPopup from "./MultipleAssignmentPopup";
import CustomerDetailPopUp from "../../Customer/CustomerDetailPopUp.vue";
import SendComments from "@/components/Pop-ups/SendComments";
import GenerateAdvance from "@/components/Pop-ups/GenerateAdvance";
import ViewDetails from "@/components/Pop-ups/ViewDetails";
import additionalChargesPopup from "@/components/JobDocuments/additionalChargesPopup";
import generateAdvancePopup from "@/components/JobDocuments/generateAdvancePopup";
import ConfirmationDialog from "../../Common/ConfirmationDialog.vue";
import CustomerAdvancePopup from "@/components/Common/CustomerAdvancePopup.vue";
import {
  updateAssignmentCustomerAdvance,
  updateJobCustomerAdvance,
} from "@/constants/api-urls";
import downloadMixin from "@/mixins/downloadMixin";
import PendingAmountList from "../Popups/PendingAmountList";
import AdvancePaid from "../Popups/AdvancePaid.vue";
import AdvanceReadyToPay from "../Popups/AdvanceReadyToPay.vue";
import { EventBus } from "../../../event-bus.js";
import pagination from "@/components/Pagination/pagination";
import {
  getModeIcon,
  getOperatorPriceLabel,
  getOperatorRoleLabel,
  getUnitNoLabel,
} from "@/utils/shipmentLabels";
import {
  apiErrorMessage,
  applyRebuiltInvoice,
} from "@/utils/customerAdvance";
let momentTz = require("moment-timezone");
export default {
  mixins: [downloadMixin],
  computed: {
    /* Generating asks whether there is an advance at all. Downloading an
       invoice that already has one is an edit, so it is worded as one. */
    customerAdvanceCopy() {
      if (this.customerAdvanceMode == "download") {
        /* This list shows both invoices, so say which one is being edited
           when the advance belongs to the job rather than the assignment. */
        const isJobLevel = this.customerAdvanceType == "job";
        return {
          title: "Edit Customer Advance",
          message: isJobLevel
            ? "This is a job level sales invoice. Do you want to update the customer advance on it?"
            : "Do you want to update the customer advance for this shipment?",
          hint: isJobLevel
            ? "The amount applies to the whole job, not just this assignment."
            : "Change the amount, or choose No to keep it as it is.",
          yesText: "Update",
        };
      }
      return {
        title: "Customer Advance",
        message: "Is there any customer advance for this shipment?",
        hint: "Enter the amount, or choose No if there is no advance.",
        yesText: "Yes",
      };
    },
    modeAwareHeaders() {
      const mode =
        this.subJobType && typeof this.subJobType === "object"
          ? this.subJobType.value
          : this.subJobType;

      return this.headers.map((header) => {
        if (header.value === "driverDetails") {
          return { ...header, text: getOperatorRoleLabel(mode) };
        }
        if (header.value === "truckDetails") {
          return { ...header, text: getUnitNoLabel(mode) };
        }
        if (header.value === "driverPrice") {
          return { ...header, text: getOperatorPriceLabel(mode) };
        }
        return header;
      });
    },
  },
  created() {
    this.getSearchList();
    this.JobTypes = JobListTypes;
    this.subTruck = TruckTypes;
    this.TruckTypesList = TruckArray;

    this.$eventBus.$on("accounts-purchase-invoice", (data) => {
      if (data.isPurchaseInvoiceForAdditionalCharges) {
        this.items.forEach((e) => {
          if (data.socketPurchInvoiceData.assignmentId === e.assignmentId) {
            console.log(e);

            // console.log(data.socketPurchInvoiceData);
            // console.log(Object.keys(data.socketPurchInvoiceData));
            // console.log(Object.keys(e));
            // for (let x in data.socketPurchInvoiceData) {
            //   console.log("trrr", x);
            // }
            // data.socketPurchInvoiceData.totalReadyToPayAmount = "3000";
            for (const key in e)
              if (key in data.socketPurchInvoiceData)
                e[key] = data.socketPurchInvoiceData[key];
            // console.log(data.socketPurchInvoiceData);
          }

          return e;
        });
      } else {
        this.refresh();
      }
    });
    this.$eventBus.$on("accounts-purchase-invoice2", (data) => {
      console.log(data, "accounts-purchase-invoice2");
      // if (data.isSalesInvoiceForAdditionalCharges) {
      //   this.items.forEach((e) => {
      //     if (data.socketSalesInvoiceData.assignmentId === e.assignmentId) {

      //       for (const key in e)
      //         if (key in data.socketSalesInvoiceData)
      //           e[key] = data.socketSalesInvoiceData[key];

      //     }

      //     return e;
      //   });
      // } else {
      setTimeout(() => {
        this.refresh();
      }, 1000);
      // }
    });
    this.$eventBus.$on("accounts-purchase-order", (data) => {
      if (!data.isPurchaseOrderForAdditionalCharges) {
        this.refresh();
      }
    });
    this.$eventBus.$on("accounts-sales-order", (data) => {
      if (!data.isSalesOrderForAdditionalCharge) {
        this.refresh();
      }
    });
    this.$eventBus.$on("accounts-sales-invoice", (data) => {
      this.refresh();
    });

    EventBus.$on("countryChanged", (val) => {
      this.workingCountry = JSON.stringify(val);
      this.loading = true;
      if (this.$route.name == "Advance") {
        if (this.$route.query) {
          //   this.search = "";
          //   this.searchTypes = "";
          //   this.$router.push(`/accounts/advance`).catch(() => {});
          // } else {
          this.search = "";
          this.searchTypes = "";
          this.generateInvoiceCount = 0;
          this.showCheckbox = false;
          this.paginationURL = `/dmsAdmin/accountAssignmentView?workingCountry=${this.workingCountry}&isSearch=true`;
          this.getListCount();
        }
      }
    });

    if (localStorage.getItem("workingCountries")) {
      if (this.$route.query && this.$route.query.type) {
        this.searchTypes = { status: "Assignment ID", abbr: "assignmentId" };
        this.search = this.$route.query.type;

        let workingCountry = [];
        workingCountry.push(this.$route.query.country);
        this.workingCountry = JSON.stringify(workingCountry);
        this.paginationURL = `/dmsAdmin/accountAssignmentView?workingCountry=${this.workingCountry}&isSearch=true&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
        this.getListCount();
        return;
      }

      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      this.workingCountry = JSON.stringify(workingCountry);

      this.paginationURL = `/dmsAdmin/accountAssignmentView?workingCountry=${this.workingCountry}&isSearch=true`;
      this.getListCount();
    }
    this.$eventBus.$on("finance", (data) => {
      if (this.$route.name === "Advance") {
        if (localStorage.getItem("workingCountries")) {
          this.workingCountries = JSON.parse(
            localStorage.getItem("workingCountries")
          );
          let workingCountry = [];
          this.workingCountries.forEach((key, index) => {
            if (key.isSelected) {
              workingCountry.push(key.value);
            }
          });
          this.workingCountry = JSON.stringify(workingCountry);
        }
        if (this.workingCountry.includes(data)) {
          this.componentKey = this.componentKey + 1;
          this.getListCount();
        }
      }
    });

    this.$eventBus.$on("job-details-purchase-invoice", (data) => {
      if (this.workingCountry.includes(data)) {
        this.componentKey = this.componentKey + 1;
      }
    });
    this.$eventBus.$on("togglePurchaseInvoiceSwitch", (data) => {
      if (this.workingCountry.includes(data)) {
        this.componentKey = this.componentKey + 1;
      }
    });

    // this.$eventBus.$on("finance", (data) => {
    //   if (this.$route.name === "Advance") {
    //     if (localStorage.getItem("workingCountries")) {
    //       this.workingCountries = JSON.parse(
    //         localStorage.getItem("workingCountries")
    //       );
    //       let workingCountry = [];
    //       this.workingCountries.forEach((key, index) => {
    //         if (key.isSelected) {
    //           workingCountry.push(key.value);
    //         }
    //       });
    //       this.workingCountry = JSON.stringify(workingCountry);
    //     }
    //     if (this.workingCountry.includes(data.workingCountry)) {
    //       this.componentKey = this.componentKey + 1;
    //       this.getListCount();
    //     }
    //   }
    // });
    this.$eventBus.$on("assignments", (data) => {
      if (this.$route.name === "Advance") {
        if (this.workingCountry.includes(data.workingCountry)) {
          this.componentKey = this.componentKey + 1;
          this.getListCount();
        }
      }
    });

    // this.$eventBus.$on("job-details-purchase-invoice", (data) => {

    //   this.items.forEach((e) => {
    //     if (data.assignmentId === e.assignmentId) {
    //

    //       e.totalAdditionalAmount = data.totalAdditionalAmount;
    //     }

    //     return e;
    //   });
    //   if (this.workingCountry.includes(data)) {
    //     this.componentKey = this.componentKey + 1;
    //   }
    // });

    this.$eventBus.$on("additionalchargeAdd", (data) => {
      if (this.$route.name === "Advance") {
        // if (this.workingCountry.includes(data.workingCountry)) {
        //   this.componentKey = this.componentKey + 1;
        //   this.getListCount();
        // }
        if (data.assignmentId) {
          this.items.forEach((e) => {
            if (data.assignmentId === e.assignmentId) {
              e.totalAdditionalAmount =
                data.totalAdditionalAmount > 0 ? data.totalAdditionalAmount : 0;
              e.totalCostMarginAdditionalAmount =
                data.totalCostMarginAmount > 0 ? data.totalCostMarginAmount : 0;
            }

            return e;
          });
        } else {
          this.componentKey = this.componentKey + 1;
          this.getListCount();
        }
      }
    });
  },

  components: {
    FinanceControlShell,
    GenerateInvoiceDialog,
    FilterBoard,
    ScrollableTable,
    SegmentedControl,
    pagination,
    PendingAmount,
    SendSI,
    AllDocuments,
    PaymentDone,
    EditPendingAmount,
    AdvancePaid,
    PendingAmountList,
    ProofOfDelivery,
    AssignmentInvoicePopup,
    AdvanceReadyToPay,
    activityLogs,
    CustomerDetailPopUp,
    confirmationPopup,
    CancellationPopup,
    SendComments,
    DocApproval,
    additionalChargesPopup,
    MultipleAssignmentPopup,
    generateAdvancePopup,
    GenerateAdvance,
    ConfirmationDialog,
    CustomerAdvancePopup,
    ViewDetails,
    AddProofDoc,
    Loading,
    SuccessDialog,
  },

  data() {
    return {
      active: "0",
      options: {
        color: "#ffc04c",
        width: 400,
        zIndex: 200,
      },

      componentKey: 0,
      dialogPi: false,
      dialogRetry: false,
      SelectAssignmentStatus: null,
      showCheckbox: false,
      airTypes: AirTypes,
      seaTypes: SeaTypes,
      pagination: {},
      TruckTypesList: [],
      salesAssignId: null,
      invoiceDialog: false,
      loading: true,
      paginationURL: ``,
      id: "",
      waterMark: "Select a Range",
      dateRange2: null,
      advanceRequested: 0,
      advanceRequestedAmount: 0,
      advanceReadyToPayAmount: 0,
      failedAdvanceAmount: 0,
      failedAdvanceAmountCount: 0,

      totalPendingFinalPayAmount: 0,
      totalPendingFinalPayCount: 0,
      finalPaymentRbFailedAmount: 0,
      finalPaymentRbFailedCount: 0,
      totalFinalFailedAmount: 0,
      totalFinalFailedCount: 0,
      internalFailedAmount: 0,
      internalFailedCount: 0,
      rbretryButtonShow: "",
      rbretryButtonShowFinal: "",
      advancePaidTotalAmount: 0,
      advanceReadyToPay: 0,
      advancePaidAmount: 0,
      invoicingCity: "",
      invoicingCountry: "",
      bankInfo: [],
      bankName: [],
      bank: "",
      beneficiaryName: "",
      branchCode: "",
      ibanNo: "",
      swiftCode: "",
      accountNo: "",
      bankId: "",
      dialog1: false,
      customerAdvanceDialog: false,
      customerAdvanceCurrency: "",
      customerAdvanceMax: null,
      customerAdvanceAmount: null,
      customerAdvanceId: null,
      customerAdvanceType: "assignment",
      customerAdvanceMode: "generate",
      pendingSiRequest: null,
      pendingDownload: null,
      dateRange: { startDate: "", endDate: "" },
      startDate: "",
      endDate: "",
      finalPayment: 0,

      readyToPay: 0,
      readyToPayAmount: 0,
      workingCountry: null,
      assignmentData: {},
      driverDetailHeaders: {
        id: "ID",
        name: "Name",
        phone: "Phone No.",
      },
      transporterDetailHeaders: {
        id: "ID",
        name: "Name",
        email: "Email",
        phone: "Phone No.",
      },
      selectCountryDialog: false,
      error: null,
      JobTypes: [],
      confirmationDialog: {
        cancelAssignment: false,
        makePayment: false,
        completeAssignment: false,
        removeDriverAssignment: false,
        removeTransporterAssignment: false,
      },
      items: [],
      changeTab: "advanceDetail",
      headers: accountAdvanceSummaryList,
      expandedAssignmentIds: [],
      advanceStatusList: [],
      pages: 1,
      rules: {
        required: (value) => !!value || "This field is required.",
        emailRules: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) ||
          "E-mail must be valid",
        countryCode: (v) =>
          /^(\+?\d{1,3}|\d{1,4})$/.test(v) ||
          "Please Enter Valid Country Code.",
        phoneNumber: (v) =>
          /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/.test(v) ||
          "Please Enter Valid Mobile No.",
        number: (v) => /^[0-9]*$/.test(v) || "Please Enter Valid Price",
      },
      statusList: [],
      statusListInProgress: [],

      statusListCompleted: [],
      selectedCustomerDataInvoice: null,
      assignStatus: "",
      finalPaymentStatus: false,
      advanceStatus: "",
      driverSearch: "",
      selected: [],
      selectedids: [],
      selectednames: [],
      headerVatPopup: "",
      messageVat: "",
      ConfirmMessageVat: "",
      headingRetryPopup: "",
      messageRetryPopup: "",
      FinalvatApply: false,
      vatInfo: null,
      vatAmount: null,
      driverSearchTypes: "",
      subJobType: "",
      searchTypes: "",
      search: "",
      subTruck: [],
      totalPages: 0,
      totalJob: 0,
      x: {
        message: "The advance payment has been successfully done",
        loading: true,
        success: false,
        heading: "Advance Payment Update",
        menu: false,

        error: null,
        missingField: null,
      },
      finalReadyToPay: 0,
      generateInvoiceCount: 0,

      subTruckType: "",
      searchItems: [
        {
          status: "Company Name/Customer Name",
          abbr: "companyName/customerName",
        },
        { status: "Job ID", abbr: "jobId" },
        { status: "Assignment ID", abbr: "assignmentId" },
        { status: "Driver ID", abbr: "driverId" },
        {
          status: "Driver Name",
          abbr: "driverName",
        },
        { status: "Truck Number", abbr: "truckNumber" },
        { status: "Tranporter ID", abbr: "transporterId" },
        {
          status: "Transporter Name",
          abbr: "Transporter Name",
        },
      ],
      driverSearchItems: [
        {
          status: "Company Name/Customer Name",
          abbr: "companyName/customerName",
        },
        { status: "Job ID", abbr: "jobId" },
        { status: "Assignment ID", abbr: "assignmentId" },
        { status: "Driver ID", abbr: "driverId" },
        {
          status: "Driver Name",
          abbr: "driverName",
        },
        { status: "Truck Number", abbr: "truckNumber" },
        { status: "Tranporter ID", abbr: "transporterId" },
        {
          status: "Transporter Name",
          abbr: "Transporter Name",
        },
      ],
    };
  },
  watch: {
    count1(val) {
      this.generateInvoiceCount = val;
    },

    dateRange2(val) {
      if (val) {
        if (val[0] && val[1]) {
          this.startDate = moment(val[0]).format("YYYY-MM-DD");
          this.endDate = moment(val[1]).format("YYYY-MM-DD");
        }
        this.searchData(null, val);
        this.getListCount();
      } else {
        this.startDate = "";
        this.endDate = "";

        this.searchData(null, val);
        this.getListCount();
      }
    },
    "$route.query.type"() {
      if (this.$route.query && this.$route.query.type) {
        this.searchTypes = { status: "Assignment ID", abbr: "assignmentId" };
        this.search = this.$route.query.type;

        let workingCountry = [];
        workingCountry.push(this.$route.query.country);
        this.workingCountry = JSON.stringify(workingCountry);
        this.paginationURL = `/dmsAdmin/accountAssignmentView?workingCountry=${this.workingCountry}&isSearch=true&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
        this.getListCount();
        return;
      }
      // } else {
      //   this.paginationURL = `/dmsAdmin/accountAssignmentView?workingCountry=${this.workingCountry}&isSearch=true`;
      //   this.getListCount();
      // }
    },

    pagination(val) {
      let temp_url = "";
      if (val["sortBy"] === "createdDate") {
        if (val["descending"] === true) {
          temp_url = "&toSort=date&sortBy=ascending";
          this.updateQueryStringParameter("toSort", "date");
          this.updateQueryStringParameter("sortBy", "descending");
        } else if (val["descending"] === false) {
          temp_url = "&toSort=date&sortBy=descending";
          this.updateQueryStringParameter("toSort", "date");
          this.updateQueryStringParameter("sortBy", "ascending");
        }
      }
      if (val["sortBy"] === "quote") {
        if (val["descending"] === true) {
          temp_url = "&toSort=price&sortBy=descending";
          this.updateQueryStringParameter("toSort", "price");
          this.updateQueryStringParameter("sortBy", "descending");
        } else if (val["descending"] === false) {
          temp_url = "&toSort=price&sortBy=ascending";
          this.updateQueryStringParameter("toSort", "price");
          this.updateQueryStringParameter("sortBy", "ascending");
        }
      }
      if (!val["sortBy"]) {
        // this.removeParam(["toSort", "sortBy"]);
      }
      this.updateQueryStringParameter("isSearch", "true");
      deep: true;
    },
  },
  methods: {
    getModeIcon,
    getOperatorPriceLabel,
    getOperatorRoleLabel,
    handleAssignmentRowClick(event) {
      if (!event || !event.target || !event.target.closest) return;

      if (
        event.target.closest(
          [
            "button",
            "a",
            "input",
            "select",
            "textarea",
            "[role='button']",
            ".v-btn",
            ".v-icon",
            ".v-input",
            ".v-menu",
            ".v-tooltip",
          ].join(",")
        )
      ) {
        return;
      }

      const row = event.target.closest("tbody tr");
      const assignmentCell = row
        ? row.querySelector("[data-assignment-id]")
        : null;

      if (assignmentCell) {
        this.toggleAssignmentDetails(
          assignmentCell.getAttribute("data-assignment-id")
        );
      }
    },
    isAssignmentExpanded(id) {
      return this.expandedAssignmentIds.indexOf(id) !== -1;
    },
    toggleAssignmentDetails(id) {
      const expandedIds = this.expandedAssignmentIds.slice();
      const index = expandedIds.indexOf(id);

      if (index === -1) {
        expandedIds.push(id);
      } else {
        expandedIds.splice(index, 1);
      }

      this.expandedAssignmentIds = expandedIds;
    },
    setCustomerValues(val) {
      var data = this.bankInfo.filter((v) => {
        if (v.value === val) return v;
      });
      (this.beneficiaryName = data[0].beneficiaryName),
        (this.branchCode = data[0].branchCode),
        (this.accountNo = data[0].accountNo),
        (this.ibanNo = data[0].ibanNo),
        (this.bankId = data[0].bankId),
        (this.swiftCode = data[0].swiftCode);
      // this.beneficiaryName = data[0].beneficiaryName;
    },
    hideUnhidePI(val, id) {
      this.loading = true;

      let url = "/assignments/purchase-invoice-switch";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        assignmentId: id.toString(),
        isPurchaseInvoiceDownloadAllowed: val,
      };

      this.axios.patch(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.loading = false;
          this.refresh();
        },
        (err) => {
          this.loading = false;
        }
      );
    },
    confirmationPiGenerate(data) {
      if (data == "With VaT") {
        this.ConfirmMessageVat = "Are you sure you want to apply VAT?";
        this.dialogPi = true;
        this.FinalvatApply = true;
      } else {
        this.FinalvatApply = false;
        this.ConfirmMessageVat = "Are you sure you don't want to apply VAT?";
        this.dialogPi = true;
      }
    },

    checkDataForSIGeneration(
      piGenerated,
      piPdfUrl,
      assignStatus,
      paymentAmount,
      totalAdditionalAmount,
      totalAdvancePaidAmount,
      amountPaidToDriver,
      country,
      rbEntryFailed
    ) {
      if (piPdfUrl && country != "PAK" && piGenerated) {
        if (
          this.searchTypes.abbr == "driverId" ||
          this.searchTypes.abbr == "transporterId"
        ) {
          if (
            paymentAmount +
              totalAdditionalAmount -
              totalAdvancePaidAmount -
              amountPaidToDriver <
              0 ||
            assignStatus !== 3 ||
            rbEntryFailed
          ) {
            return true;
          }
        } else {
          return false;
        }
      } else if (country == "PAK") {
        if (
          this.searchTypes.abbr == "driverId" ||
          this.searchTypes.abbr == "transporterId"
        ) {
          if (
            paymentAmount +
              totalAdditionalAmount -
              totalAdvancePaidAmount -
              amountPaidToDriver <
              0 ||
            assignStatus !== 3
          ) {
            return true;
          }
        } else if (
          this.searchTypes.abbr == "jobId" ||
          this.searchTypes.abbr == "assignmentId"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    closeBankInfo() {
      this.dialog1 = false;
      this.customerAdvanceAmount = null;
      this.invoiceDay = null;
      this.isMultipleInvoiceFailed = false;
      this.bankInfo = [];
      this.bank = "";
      (this.beneficiaryName = ""),
        (this.branchCode = ""),
        (this.accountNo = ""),
        (this.ibanNo = ""),
        (this.bankId = ""),
        (this.swiftCode = "");
    },

    async checkViewInvoice(
      url,
      isDownloadInvocie,
      isPurchaseInvoviceBackgroundProcess,
      invoiceNumber
    ) {
      this.loading = true;
      this.operationName = "generate-downaload-po-pi-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.loading = false;
        if (isPurchaseInvoviceBackgroundProcess) {
          this.loading = false;
          this.error =
            "Purchase Invoice can't be downloaded, background process is ongoing ";
          return;
        }
        /* Mixin function*/
        this.forceDownload(url, "Purchase Invoice" + " " + invoiceNumber);
      } else {
        this.loading = false;
        return;
      }
    },

    async checkViewInvoice2(
      url,
      isDownloadInvocie,
      isPurchaseInvoviceBackgroundProcess,
      invoiceNumber
    ) {
      this.loading = true;
      this.operationName = "generate-downaload-po-pi-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.loading = false;
        if (isPurchaseInvoviceBackgroundProcess) {
          this.loading = false;
          this.error =
            "Purchase Invoice can't be downloaded, background process is ongoing ";
          return;
        }
        /* Mixin function*/
        this.forceDownload(url, "Sales Invoice" + " " + invoiceNumber);
      } else {
        this.loading = false;
        return;
      }
    },

    async generateInvoiceNumber(vatType) {
      this.loading = true;
      this.operationName = "generate-downaload-po-pi-for-accounts";

      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        // this.loading = true;

        let url = "/dmsAdmin/generatePurchaseInvoice";
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = { assignmentId: this.id.toString() };
        if (this.vatAmount > 0 && vatType == "Yes") {
          body.vatAmount = this.vatAmount;
        }
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.invoiceDialog = false;
            this.dialogPi = false;
            this.loading = false;
            this.refresh();
          },
          (error) => {
            this.dialogPi = false;
            this.loading = false;
            this.error = error.response.data.message;
            this.invoiceDialog = false;
          }
        );
      } else {
        this.loading = false;
        return;
      }
    },

    async generateInvoiceNumber2() {
      this.loading = true;
      this.operationName = "generate-downaload-so-si-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (!this.bank) {
        this.loading = false;
        this.error = "Please Choose Bank Before Generate Invoice";
        return;
      }
      if (y) {
        this.loading = true;

        let url = "/dmsAdmin/generate-assignment-invoice";
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };

        let body = {
          assignmentIds: [this.salesAssignId],
          bankId: this.bankId,
          type: "INVOICE_PER_ASSIGNMENT",
        };
        /* Customer advance is UAE only. KSA and every other working country
           keep the payload they had before. */
        if (
          this.SelectAssignmentStatus &&
          this.SelectAssignmentStatus.workingCountry == "UAE" &&
          this.customerAdvanceAmount !== null
        ) {
          body.customerAdvance = this.customerAdvanceAmount;
        }
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            //this.items = response.data.data;
            this.loading = false;
            this.closeBankInfo();
            this.customerAdvanceAmount = null;

            this.componentKey = this.componentKey + 1;
            // this.x.message = "Drivers notified";
          },
          (error) => {
            this.loading = false;
            this.error = error.response.data.message;
          }
        );
      } else {
        this.loading = false;
        return;
      }
    },

    count1(val) {
      this.generateInvoiceCount = val;
    },

    openPiGenerate(assignmentId, assId) {
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.t = config.headers.authorization;
      let body = {
        assignmentId: assId,
      };
      this.axios
        .post(`${this.constants.apiUrl}/dmsAdmin/get-vat-details`, body, config)
        .then((response) => {
          if (response.data.data.amount > 0) {
            this.vatInfo = true;
            this.invoiceDialog = true;
            this.headerVatPopup = "Generate Purchase Invoice With VAT";
            this.messageVat = ` Do you want to generate Purchase Invoice with  VAT ${
              response.data.data.vatPercent
            } % (${response.data.data.amount.toFixed(2)} ${
              response.data.data.currency
            }) ?`;
            this.vatAmount = response.data.data.amount;
          } else {
            this.invoiceDialog = true;
            this.vatInfo = false;

            this.headerVatPopup = "Generate Purchase Invoice";
            this.messageVat = ` Do you want to generate Purchase Invoice ?`;
          }
        });

      this.cancelloading = false;
      this.loading = false;
      this.id = assignmentId;
    },
    async openSiPopup(userData, id, assData) {
      /* For UAE, ask for the customer advance first. Every other working
         country, and anyone who cannot generate the sales invoice, keeps
         going straight into the existing sales invoice flow. */
      this.operationName = "generate-downaload-so-si-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (assData && assData.workingCountry == "UAE" && y) {
        this.customerAdvanceAmount = null;
        this.customerAdvanceCurrency = assData.customerCurrency || "";
        /* The cap is the customer amount that comes back with the saved
           advance, so nothing is set here. */
        this.customerAdvanceMax = null;
        /* The popup prefills itself from this assignment's saved advance. */
        this.customerAdvanceId = id;
        this.customerAdvanceType = "assignment";
        this.customerAdvanceMode = "generate";
        this.pendingSiRequest = { userData, id, assData };
        this.customerAdvanceDialog = true;
        return;
      }
      this.startSiFlow(userData, id, assData);
    },

    /* Downloading an invoice that already has an advance is an edit, so it
       asks first and then hands back the regenerated PDF. "job" is the job
       level invoice shown on the row, "assignment" the assignment's own. */
    async openDownloadAdvance(item, level, e) {
      if (e) e.stopPropagation();
      const isJob = level == "job";
      const job = item.jobData || {};
      this.pendingDownload = isJob
        ? {
            url: job.invoicePdfUrl,
            isDownloadInvocie: item.isDownloadInvocie,
            isSaleInvoviceBackgroundProcess: job.isSaleInvoviceBackgroundProcess,
            invoiceNumber: job.invoiceNumber,
          }
        : {
            url: item.salesInvoicePdfUrl,
            isDownloadInvocie: item.isDownloadInvocie,
            isSaleInvoviceBackgroundProcess: item.isSaleInvoviceBackgroundProcess,
            invoiceNumber: item.salesInvoiceNumber,
          };
      /* Only whoever can generate the sales invoice may edit the advance,
         everyone else just downloads it. */
      this.operationName = "generate-downaload-so-si-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (item.workingCountry != "UAE" || !y) {
        this.runPendingDownload();
        return;
      }
      this.customerAdvanceAmount = null;
      this.customerAdvanceCurrency =
        item.customerCurrency || job.customerCurrency || "";
      /* Jobs and assignments both cap on the customer amount that comes back
         with the saved advance, so nothing is set here. The popup prefills
         itself from whichever record the invoice belongs to. */
      this.customerAdvanceMax = null;
      this.customerAdvanceType = isJob ? "job" : "assignment";
      this.customerAdvanceId = isJob ? item.jobId : item._id;
      this.customerAdvanceMode = "download";
      this.customerAdvanceDialog = true;
    },

    runPendingDownload() {
      const pending = this.pendingDownload;
      this.pendingDownload = null;
      if (!pending) return;
      this.checkViewInvoice2(
        pending.url,
        pending.isDownloadInvocie,
        pending.isSaleInvoviceBackgroundProcess,
        pending.invoiceNumber
      );
    },

    /* Both No and Yes resume the flow that opened the popup, Yes also keeps
       whatever amount was entered. */
    onCustomerAdvanceConfirm({ confirmed, amount }) {
      this.customerAdvanceAmount = amount;

      if (this.customerAdvanceMode == "download") {
        if (confirmed && amount !== null) this.saveAdvanceThenDownload(amount);
        else this.runPendingDownload();
        return;
      }

      const pending = this.pendingSiRequest;
      this.pendingSiRequest = null;
      if (!pending) return;
      this.startSiFlow(pending.userData, pending.id, pending.assData);
    },

    onCustomerAdvanceCancel() {
      this.customerAdvanceAmount = null;
      this.pendingSiRequest = null;
      this.pendingDownload = null;
    },

    /* Editing the advance regenerates the invoice, so the download holds
       until the new PDF arrives rather than handing back the stale one. */
    saveAdvanceThenDownload(amount) {
      const isJob = this.customerAdvanceType == "job";
      const recordId = this.customerAdvanceId;
      const fallbackNumber = this.pendingDownload
        ? this.pendingDownload.invoiceNumber
        : "";
      this.pendingDownload = null;
      this.customerAdvanceAmount = null;
      if (!recordId) return;

      this.loading = true;
      const token = localStorage.getItem(StorageKeys.SessionKey);
      const config = { headers: { authorization: `bearer ${token}` } };
      const body = isJob
        ? { jobId: recordId.toString(), customerAdvance: amount }
        : { assignmentId: recordId.toString(), customerAdvance: amount };
      const url = isJob
        ? updateJobCustomerAdvance
        : updateAssignmentCustomerAdvance;
      delete this.axios.defaults.headers.common["token"];
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.loading = false;
          const payload = response.data || {};
          const data = payload.data || payload;
          /* The rebuilt PDF is uploaded under a fresh name, so its URL comes
             back on this response. The list is cached and would still hand
             back the previous one. The assignment call returns every
             assignment on the invoice, so pick this one out. */
          const invoice = isJob
            ? data
            : (Array.isArray(data) ? data : []).find(
                (row) => String(row._id) == String(recordId)
              ) || (Array.isArray(data) ? data[0] : null);
          const pdfUrl =
            invoice &&
            (isJob ? invoice.invoicePdfUrl : invoice.salesInvoicePdfUrl);
          if (!pdfUrl) {
            this.error =
              "The invoice was updated but its PDF link was not returned. Please try the download again.";
          } else {
            this.checkViewInvoice2(
              pdfUrl,
              true,
              false,
              (isJob ? invoice.invoiceNumber : invoice.salesInvoiceNumber) ||
                fallbackNumber
            );
          }
          /* On a combined invoice the rebuilt PDF belongs to several jobs,
             so every assignment sitting under one of them gets the new link.
             The job invoice lives on the row's jobData. */
          if (isJob) {
            applyRebuiltInvoice(
              this.items.map((row) => row.jobData).filter(Boolean),
              invoice,
              (job) => job.jobId
            );
          }
          /* Refresh so the row reflects the new advance and PDF link. */
          this.componentKey = this.componentKey + 1;
        },
        (error) => {
          this.loading = false;
          this.error = apiErrorMessage(
            error,
            "Could not save the customer advance."
          );
        }
      );
    },

    startSiFlow(userData, id, assData) {
      this.SelectAssignmentStatus = assData;
      this.dialog1 = true;
      this.userDetail = userData;
      this.fetchBank();
      this.salesAssignId = id;
    },

    //fectch Bank details for Sales Invoice

    fetchBank() {
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        invoicingCity: {
          code: this.SelectAssignmentStatus.invoicingCity,
        },
        invoicingCountry: {
          code: this.SelectAssignmentStatus.invoicingCountry,
        },
      };
      let { apiUrl } = this.constants;
      this.axios.post(`${apiUrl}/accounts/getBankDetails`, body, config).then(
        (response) => {
          const { data = null } = response.data;
          /* Replace, never append, so reopening the bank step does not list
             every bank again. */
          this.bankInfo = data.map((element) => ({
            text: element.bankName,
            value: element._id,
            beneficiaryName: element.beneficiaryName,
            branchCode: element.branchCode,
            accountNo: element.accountNo,
            ibanNo: element.ibanNo,
            bankId: element._id,
            swiftCode: element.swiftCode,
            
            // companyName: element.companyName,
            // companyVatNumber: element.companyVatNumber,
            // address: element.address
            //   ? element.address.replaceAll("\n", ", ")
            //   : "",
            // invoicingCity: element.invoicingCity,
            // invoicingCountry: element.invoicingCountry,
            // selectedIndustry: element.selectedIndustry,
          }));

          // this.bankName = response.data.data[2].bankName;
        },
        (error) => {
          this.error = "Something went wrong. Please try again later!";
          this.loading = false;
        }
      );
    },

    refreshOnComment() {
      this.componentKey++;
    },

    resetInvoiceIds() {
      this.selectedids = [];
      this.selectednames = [];
      this.generateInvoiceCount = 0;
    },

    checkSelected(select, id, e) {
      if (select && !this.selectedids.includes(id)) {
        this.generateInvoiceCount = this.generateInvoiceCount + 1;
        this.$emit("count", this.generateInvoiceCount);
        this.selectedids.push(id);
        this.selectednames.push(id);
      }
      if (!select && this.selectedids.includes(id)) {
        this.generateInvoiceCount = this.generateInvoiceCount - 1;
        this.$emit("count", this.generateInvoiceCount);
        this.selectedids.splice(this.selectedids.indexOf(id), 1);
        this.selectednames.splice(this.selectednames.indexOf(id), 1);
      }

      this.selectedCustomerDataInvoice = this.items[0];
    },

    getAdvanceAmount(data) {
      let pendingAmount = this.getPendingAmountForProps(data, true);
      return `${pendingAmount}  ${data.customerCurrency}`;
    },
    getPendingAmountForProps(data, isDecimal = false) {
      let amountPaidToDriver = data.amountPaidToDriver || 0;
      let adjustAmount = data.amountAdjustedFromThisAssignment || 0;
      let totalAdvance =
        data.paymentAmount -
        (data.totalAdvancePaidAmount - adjustAmount) -
        amountPaidToDriver +
        data.totalAdditionalAmount;

      if (isDecimal) return totalAdvance.toFixed(2);
      else return Number(totalAdvance.toFixed(2));
    },
    goToProof(_id) {
      this.$router.push(`/documents/${_id}?type=Driver_Proof`);
    },
    getSearchList() {
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };

      const url = `${this.constants.apiUrl}/dmsAdmin/searchListArray`;
      this.axios.get(url, config).then((response) => {
        this.statusListInProgress = response.data.data.assignStatusInProgress;
        this.statusListCompleted = response.data.data.assignStatusCompleted;

        this.statusList = this.statusListInProgress.concat(
          this.statusListCompleted
        );
        // this.statusList.push({
        //   text: "RB Entry Failed",
        //   value: "RB_Entry_Failed",
        //   wantToDisplay: true,
        // });
        this.advanceStatusList = response.data.data.AdvanceStatusAccountsList;
      });
    },
    goToDoc(jobId, assignId, _id) {
      this.$router.push(`/documents/${_id}`);
    },
    async check(jobId) {
      this.operationName = "view-details-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.$router.push(`/jobs/${jobId}`);
      } else {
        return;
      }
    },
    getText(arr = [], val) {
      let finalEl = null;
      finalEl = arr.find((el) => el.value == val);
      return finalEl ? finalEl.text : "NA";
    },
    async callback({ jobInfo }) {
      this.items = jobInfo;
      this.items.forEach((e) => {
        e.selected = false;

        if (this.selectedids.includes(e._id)) {
          e.selected = true;
        }
      });
      this.pagination.rowsPerPage = 15;
      window.scrollTo(0, 0);
      this.loading = false;
    },
    refresh() {
      this.componentKey = this.componentKey + 1;
    },
    refreshMultiple() {
      this.selectedids = [];
      this.selectednames = [];
      this.generateInvoiceCount = 0;
      this.componentKey = this.componentKey + 1;
    },

    getStatus(status) {
      switch (status) {
        case 1:
          return "Driver Not Assigned";
        case 2:
          return "Driver Assigned";
        case 3:
          return "Payment Pending";
        case 4:
          return "Payment Done";
        case 5:
          return "In-Transit";
        case 6:
          return "Shipment Offloaded ";

        case -1:
          return "Job Cancelled";
        default:
          return "Unknown";
      }
    },
    // getListCount() {
    //   let v = {};
    //   this.paginationLoading = true;
    //   let Url = "/dmsAdmin/accountAssignmentDashboard";
    //       case -1:
    //         return "Job Cancelled";
    //       default:
    //         return "Unknown";
    //     }
    //   },
    getListCount() {
      let v = {};
      this.loading = true;
      let Url = "/dmsAdmin/accountAssignmentDashboard";

      let temp_url = this.paginationURL;
      Url = "/dmsAdmin/accountAssignmentDashboard?" + temp_url.split("?")[1];
      let body = {};
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      this.axios.defaults.headers.common["authorization"] = `bearer ${token}`;
      this.advanceRequested = 0;
      this.advanceRequestedAmount = 0;
      this.advanceReadyToPayAmount = 0;
      this.failedAdvanceAmount = 0;
      this.failedAdvanceAmountCount = 0;
      this.totalPendingFinalPayAmount = 0;
      this.totalPendingFinalPayCount = 0;
      this.finalPaymentRbFailedAmount = 0;
      this.finalPaymentRbFailedCount = 0;
      (this.totalFinalFailedAmount = 0),
        (this.totalFinalFailedCount = 0),
        (this.internalFailedAmount = 0),
        (this.internalFailedCount = 0),
        (this.advancePaidTotalAmount = 0);
      this.advanceReadyToPay = 0;
      this.advancePaidAmount = 0;
      this.finalPayment = 0;
      this.readyToPay = 0;
      this.readyToPayAmount = 0;
      this.finalReadyToPay = 0;
      this.totalPages = 0;
      this.totalJob = 0;
      v = this.axios.get(this.constants.apiUrl + Url, body).then(
        (response) => {
          this.loading = false;

          this.jobCount = response.data.data;
          let countData = this.jobCount;
          if (!this.search.trim().length) {
            localStorage.removeItem("searchAdvance");
          }
          if (!this.driverSearch.trim().length) {
            localStorage.removeItem("searchAdvanceDriver");
          }
          this.advanceRequested = countData.advanceRequested;
          this.advanceRequestedAmount = countData.advanceRequestedAmount;
          this.advanceReadyToPayAmount = countData.advanceReadyToPayAmount;
          this.failedAdvanceAmount = countData.advanceRbFailedTotalAmount;
          this.failedAdvanceAmountCount = countData.advanceRbFailedAmount;
          this.totalPendingFinalPayAmount =
            countData.paymentPendingEntriesAmountTotal;
          this.totalPendingFinalPayCount = countData.totalPendingPaymentEntries;
          this.finalPaymentRbFailedAmount =
            countData.finalPaymentRbFailedAmount;
          this.finalPaymentRbFailedCount =
            countData.finalPaymentRbFailedTotalEntries;
          this.totalFinalFailedAmount = countData.finalPaymentFailedAmount;
          this.totalFinalFailedCount = countData.totalFailedEntriesCount;
          this.internalFailedAmount =
            countData.finalPaymentFailedAmount -
            countData.finalPaymentRbFailedAmount;
          this.internalFailedCount =
            countData.totalFailedEntriesCount -
            countData.finalPaymentRbFailedTotalEntries;
          this.rbretryButtonShow = countData.isRetryPossibleForRbFailure;
          this.rbretryButtonShowFinal =
            countData.isRetryPossibleForRbFinalPaymentFailure;
          this.advancePaidTotalAmount = countData.advancePaidTotalAmount;
          this.advanceReadyToPay = countData.advanceReadyToPay;
          this.advancePaidAmount = countData.advancePaidAmount;
          this.finalPayment = countData.finalPayment;
          this.readyToPay = countData.readyToPay;
          this.readyToPayAmount = countData.readyToPayAmount;
          this.finalReadyToPay = countData.finalReadyToPay;
          this.totalJob = countData.totalData;
          this.totalPages = Math.ceil(this.totalJob / 15);
        },
        (error) => {}
      );

      return v;
    },

    openTransporterUnassign(assignData) {
      this.confirmationDialog.removeTransporterAssignment = true;
      this.assignmentData = { ...assignData };
    },
    openDriverUnassign(assignData) {
      this.confirmationDialog.removeDriverAssignment = true;
      this.assignmentData = { ...assignData };
    },
    removeDriver() {
      this.confirmationDialog.removeDriverAssignment = false;
    },
    getDays(day) {
      let finalDate = moment(day);
      let dayToday = moment(new Date());
      let remainingDay = finalDate.diff(dayToday, "hours");
      return Math.round(remainingDay / 24);
    },

    remove() {
      this.confirmationDialog.removeTransporterAssignment = false;
    },
    removeTransporterAssignment(data) {
      if (
        data.assignmentStatus == 2 ||
        data.assignmentStatus == 5 ||
        data.assignmentStatus == 6
      ) {
        this.error = "Please unassign the driver first !";
        this.loading = false;
        return;
      }
      this.loading = true;
      let url = "/dmsAdmin/unassignTransporter";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const body = {
        assignmentId: data.assignmentId.toString(),
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.loading = false;
          this.confirmationDialog.removeTransporterAssignment = false;
          this.componentKey = this.componentKey + 1;
        },
        (error) => {
          this.error = this.$eventBus.parse(error);
          this.loading = false;
        }
      );
    },
    openRetryAllpopup(type) {
      if (type == "advance") {
        this.headingRetryPopup = "Confirmation";
        this.messageRetryPopup =
          " Are you sure you want to pay advance for all the real book failed  entries ?";
        this.dialogRetry = true;
      } else {
        this.headingRetryPopup = "Retry Posting Final Payment";
        this.messageRetryPopup =
          " Are you sure you want to pay  for all the failed  final payment real book entries ?";
        this.dialogRetry = true;
      }
    },
    retryAllAdvanceOrFinalPayment(type) {
      let url = "/dmsAdmin/advance/retry-rb-all-payment";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        action:
          type == "advance" ? "generateAdvanceReciept" : "finalPaymentToRB",
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.dialogRetry = false;

          this.x.message = response.data.data.message;
          (this.x.heading =
            type == "advance"
              ? "Advance Payment Update"
              : "Final Payment Update"),
            (this.x.success = true);
        },
        (error) => {
          this.dialogRetry = false;

          this.error = error.response.data.message;
        }
      );
    },
    removeDriverAssignment(data) {
      if (!data.driverData) {
        return;
      }
      let url = "/dmsAdmin/removeDriver";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const body = {
        driverId: data.driverData.driverId.toString(),
        assignmentId: data.assignmentId.toString(),
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.loading = false;
          this.componentKey = this.componentKey + 1;
          this.confirmationDialog.removeDriverAssignment = false;
        },
        (error) => {
          this.error = this.$eventBus.parse(error);
          this.loading = false;
        }
      );
    },

    updatePaginationUrl() {
      let tempUrl = localStorage.getItem("paginationUrlAdvance");
      let x = tempUrl.split("&");
      let y = x[0].split("=");
      y[1] = this.workingCountry;
      x[0] = y.join("=");
      tempUrl = x.join("&");
      this.paginationURL = tempUrl;
    },

    page(event) {
      this.pages = event;
    },

    goToProfile(jobId) {
      this.$router.push(`/jobs/${jobId}`);
    },
    getTime(time) {
      return moment.unix(time).format("ll");
    },
    getTime3(date) {
      return moment.utc(date).format("ll");
    },
    getTime4(date) {
      return moment(date).format("ll LT");
    },

    filterByTab(value) {
      if (value == "paymentDetail") {
        this.$router.push(`/accounts`);
      } else if (value == "customerDetail") {
        this.$router.push(`/accounts/customerPayment`);
      } else {
        this.$router.push(`/accounts/advance`);
      }
    },

    searchData(dateRangeVal = null) {
      if (this.searchTypes.abbr) {
        this.loading = false;
        this.driverSearchItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Driver ID", abbr: "driverId" },
          {
            status: "Driver Name",
            abbr: "driverName",
          },
          { status: "Truck Number", abbr: "truckNumber" },
          { status: "Tranporter ID", abbr: "transporterId" },
          {
            status: "Transporter Name",
            abbr: "Transporter Name",
          },
        ];

        this.driverSearchItems.forEach((k) => {
          if (k["abbr"] == this.searchTypes.abbr) {
            let elementPos = this.driverSearchItems
              .map(function (x) {
                return x.abbr;
              })
              .indexOf(k["abbr"]);

            this.driverSearchItems.splice(elementPos, 1);
          }
        });
      }
      if (this.driverSearchTypes.abbr) {
        this.searchItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Driver ID", abbr: "driverId" },
          {
            status: "Driver Name",
            abbr: "driverName",
          },
          { status: "Truck Number", abbr: "truckNumber" },
          { status: "Tranporter ID", abbr: "transporterId" },
          {
            status: "Transporter Name",
            abbr: "Transporter Name",
          },
        ];

        this.searchItems.forEach((k) => {
          if (k["abbr"] == this.driverSearchTypes.abbr) {
            let elementPos = this.searchItems
              .map(function (x) {
                return x.abbr;
              })
              .indexOf(k["abbr"]);

            this.searchItems.splice(elementPos, 1);
          }
        });
      }

      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return;
      }
      let url = [];
      url.push(`workingCountry=${this.workingCountry}`);

      url.push(`isSearch=true`);
      if (this.subJobType.value) {
        //   localStorage.setItem("subJobTypePro", JSON.stringify(this.subJobType));
        url.push(`jobType=${this.subJobType.value}`);
      }
      if (this.subTruckType) {
        //   localStorage.setItem("subJobTypePro", JSON.stringify(this.subJobType));
        url.push(`truckType=${this.subTruckType}`);
      }
      if (this.assignStatus) {
        //   localStorage.setItem("subJobTypePro", JSON.stringify(this.subJobType));
        url.push(`assignmentStatus=${this.assignStatus}`);
      }
      if (this.finalPaymentStatus && this.assignStatus == "Payment Pending") {
        url.push(`isAssignmentPaymentStatusFailed=${this.finalPaymentStatus}`);
      }

      if (dateRangeVal) {
        url.push(`startDate=${this.startDate}`);
        url.push(`endDate=${this.endDate}`);
      } else if (this.startDate.length > 0) {
        url.push(`startDate=${this.startDate}`);
        url.push(`endDate=${this.endDate}`);
      }

      if (this.advanceStatus) {
        url.push(`advanceStatus=${this.advanceStatus}`);
      }

      if (this.search.trim().length > 0 && this.searchTypes) {
        if (
          this.searchTypes.abbr == "jobId" ||
          this.searchTypes.abbr == "assignmentId" ||
          this.searchTypes.abbr == "driverId" ||
          this.searchTypes.abbr == "transporterId"
        ) {
          this.showCheckbox = true;
        }

        localStorage.setItem("searchAdvance", this.search);
        url.push(`searchType=${this.searchTypes.abbr}`);
        url.push(`searchText=${this.search}`);
      } else if (this.searchTypes) {
        if (!localStorage.getItem("searchAdvance")) {
        } else {
        }
        this.search = "";
      }

      if (this.driverSearch.trim().length > 0 && this.driverSearchTypes) {
        if (
          this.driverSearchTypes.abbr == "jobId" ||
          this.driverSearchTypes.abbr == "assignmentId" ||
          this.driverSearchTypes.abbr == "driverId" ||
          this.driverSearchTypes.abbr == "transporterId"
        ) {
          this.showCheckbox = true;
        }
        localStorage.setItem("searchAdvanceDriver", this.driverSearch);
        url.push(`searchTextTwo=${this.driverSearch}`);
        url.push(`searchTypeTwo=${this.driverSearchTypes.abbr}`);
      } else if (this.driverSearchTypes) {
        if (!localStorage.getItem("searchAssignDriver")) {
        } else {
        }
      }

      let finalUrl = "/dmsAdmin/accountAssignmentView?";
      if (url.length > 0) {
        let params = url.join("&");
        finalUrl = finalUrl + params;
      } else return "";

      this.paginationURL = finalUrl;
      if (
        localStorage.getItem("searchAdvance") ||
        localStorage.getItem("searchAdvanceDriver") ||
        this.subJobType ||
        this.advanceStatus ||
        this.assignStatus ||
        this.subTruckType
      ) {
        this.getListCount();
      } else {
      }
    },
    reset() {
      (this.selectedids = []),
        (this.selectednames = []),
        (this.assignStatus = "");
      (this.generateInvoiceCount = 0), (this.advanceStatus = "");
      this.showCheckbox = false;
      this.subJobType = "";
      this.assignStatus = "";
      this.finalPaymentStatus = "";
      this.dateRange2 = null;
      this.startDate = "";
      this.endDate = "";
      this.subTruckType = "";
      this.driverSearchTypes = "";
      this.driverSearch = "";
      this.searchTypes = "";
      this.search = "";
      this.advanceRequested = 0;
      this.advanceRequestedAmount = 0;
      this.advanceReadyToPayAmount = 0;
      this.advancePaidTotalAmount = 0;
      this.advanceReadyToPay = 0;
      this.advancePaidAmount = 0;
      this.finalPayment = 0;
      this.readyToPay = 0;
      this.readyToPayAmount = 0;
      this.failedAdvanceAmount = 0;
      this.failedAdvanceAmountCount = 0;
      this.finalReadyToPay = 0;
      this.totalPages = 0;
      this.totalJob = 0;
      this.totalPendingFinalPayAmount = 0;
      this.totalPendingFinalPayCount = 0;
      this.finalPaymentRbFailedAmount = 0;
      this.finalPaymentRbFailedCount = 0;
      // localStorage.removeItem("paginationUrlAdvance");
      // localStorage.removeItem("searchAdvance");
      // localStorage.removeItem("searchAdvanceDriver");

      let fullPath = this.$router.currentRoute.fullPath;

      this.driverSearchItems = [
        {
          status: "Company Name/Customer Name",
          abbr: "companyName/customerName",
        },
        { status: "Job ID", abbr: "jobId" },
        { status: "Assignment ID", abbr: "assignmentId" },
        { status: "Driver ID", abbr: "driverId" },
        {
          status: "Driver Name",
          abbr: "driverName",
        },
        { status: "Truck Number", abbr: "truckNumber" },
        { status: "Tranporter ID", abbr: "transporterId" },
        {
          status: "Transporter Name",
          abbr: "Transporter Name",
        },
      ];
      this.searchItems = [
        {
          status: "Company Name/Customer Name",
          abbr: "companyName/customerName",
        },
        { status: "Job ID", abbr: "jobId" },
        { status: "Assignment ID", abbr: "assignmentId" },
        { status: "Driver ID", abbr: "driverId" },
        {
          status: "Driver Name",
          abbr: "driverName",
        },
        { status: "Truck Number", abbr: "truckNumber" },
        { status: "Tranporter ID", abbr: "transporterId" },
        {
          status: "Transporter Name",
          abbr: "Transporter Name",
        },
      ];
      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.xerror = "";
        }, 3000);
        return;
      }
      this.paginationURL = `/dmsAdmin/accountAssignmentView?workingCountry=${this.workingCountry}&isSearch=true`;
      this.getListCount();
      return;
    },
    checkLoading(event) {
      if (event) {
        this.loading = true;
      } else {
        this.loading = false;
      }
    },
    closeMessage() {
      this.x.success = false;
      this.refresh();
    },
    updateQueryStringParameter(key, value) {
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = this.paginationURL.indexOf("?") !== -1 ? "&" : "?";
      if (this.paginationURL.match(re)) {
        this.paginationURL = this.paginationURL.replace(
          re,
          "$1" + key + "=" + value + "$2"
        );
      } else {
        this.paginationURL = this.paginationURL + separator + key + "=" + value;
      }
    },
  },
};
</script>

<style scss>
.pd-t-l {
  padding-left: 5px;
  padding-top: 7px;
}
div#ej2-datetimepicker_0_popup {
  left: auto !important;
  max-width: calc(100vw - 2rem);
  right: 1rem !important;
}
#accountDate .e-input-group-icon.e-range-icon.e-icons::after {
  content: none !important;
}

#accountDate span.e-input-group-icon.e-range-icon.e-icons {
  left: auto;
  margin-left: auto;
  position: static;
  right: auto !important;
  text-align: center;
  width: 1.5rem;
}
#accountDate .e-input-group-icon.e-range-icon::before,
*.e-control-wrapper .e-input-group-icon.e-range-icon::before {
  content: "\e245";
  font-family: "e-icons";
  float: none;
  position: static;
  right: auto;
}
#accountDate .e-daterangepicker {
  left: auto !important;
  max-width: calc(100vw - 2rem);
  right: 1rem;
}
.font_Bold {
  font-size: 13px;
  font-weight: 600;
  margin-top: 2px;
  font-family: inherit;
}
.reset__btn {
  position: static;
  right: auto;
  top: auto !important;
}
.total.avatar[data-v-6c1d3ab2] {
  min-width: 12rem !important;
}
.e-daterangepicker.e-popup .e-calendar,
.e-bigger.e-small .e-daterangepicker.e-popup .e-calendar {
  background-color: #fff;
  height: 100%;
}
#accountDate .e-clear-icon {
  display: none !important;
  opacity: 0;
}
.account-ass-btn {
  text-decoration: none;
  color: #ea7a1c;
  border: 2px solid #ea7a1c;
  padding: 2px 8px;
  border-radius: 5px;
  margin-top: 6px;
}
.searchAccounts .v-label.v-label--is-disabled.theme--light {
  left: 0.625rem !important;
}

.searchAccounts .theme--light.v-label {
  left: 0.625rem !important;
}

.assign-ass-btn {
  text-decoration: none;
  color: #ea7a1c;
  border: 2px solid #ea7a1c;
  padding: 2px 8px;
  border-radius: 5px;
}

.searchAccounts input {
  padding-left: 0.625rem !important;
}

div#ej2-datetimepicker_0_popup {
  left: auto !important;
  max-width: calc(100vw - 2rem);
  right: 1rem !important;
}
/* .date_9 input#ej2-datetimepicker_0 {
  font-size: 16px;
} */
</style>

<style scoped>
.divider-style {
  margin-bottom: 24px;
  margin-top: 15px;
  background: lightgrey;
}

.scrollbar {
  width: 5px;
}
.tooltip-op-comment {
  max-width: 30%;
  opacity: 1 !important;
}

.accounts-advance-comment-wrap {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
  min-width: 0;
  width: 100%;
}

.accounts-advance-comment-text {
  color: #475569;
  flex: 1 1 auto;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.35;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.accounts-advance-comment-text--empty {
  color: #94a3b8;
  font-weight: 600;
}

.accounts-advance-comment-action {
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
  margin-top: 0;
}

.accounts-advance-comment-action ::v-deep .track-ass-btn.assign-button,
.accounts-advance-comment-action ::v-deep .comment_btn.blue-button {
  align-items: center !important;
  background: #ffffff !important;
  border: 1px solid #dfe5ee !important;
  border-radius: 999px !important;
  box-shadow: none !important;
  color: #667085 !important;
  display: inline-flex !important;
  font-size: 0 !important;
  height: 32px !important;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-width: 32px !important;
  padding: 0 !important;
  width: 32px !important;
}

.accounts-advance-comment-action ::v-deep .track-ass-btn.assign-button:hover,
.accounts-advance-comment-action ::v-deep .comment_btn.blue-button:hover {
  background: #fff7ed !important;
  border-color: #fed7aa !important;
  color: #b95d07 !important;
}

.accounts-advance-comment-action ::v-deep .track-ass-btn.assign-button::before {
  content: "+";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.accounts-advance-comment-action ::v-deep .comment_btn.blue-button .v-btn__content {
  align-items: center;
  color: inherit !important;
  display: inline-flex;
  font-size: 0;
  justify-content: center;
  line-height: 1;
}

.accounts-advance-comment-action
  ::v-deep
  .comment_btn.blue-button
  .v-btn__content::before {
  content: "+";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}
.advance-btn-color {
  background-color: #e3471b !important;
  text-transform: capitalize;
  min-width: 8rem;
  width: auto;
  border-radius: 5px;
}

.div ::-webkit-scrollbar {
  width: 1 px;
}
.muted {
  font-size: 13px;
}
.accounts-advance-page .layout {
  overflow: visible;
}

.accounts-advance-bulk-actions {
  display: flex !important;
  justify-content: flex-end;
  max-width: none !important;
  padding: 0.625rem var(--oms-list-section-x, 1.5rem) 0;
  width: 100%;
}

.accounts-advance-page .accounts-payment-summary-grid {
  flex-wrap: wrap;
  gap: 0.75rem;
  padding-left: 0 !important;
}

.accounts-advance-page .accounts-payment-summary-grid > .flex {
  flex: 1 1 0 !important;
  max-width: none !important;
  min-width: 0;
}

.accounts-advance-filter-panel {
  max-width: none;
  padding: 0.75rem 1.5rem !important;
}

.accounts-advance-filter-grid {
  display: flex !important;
  flex-wrap: wrap;
  gap: 0.625rem;
  overflow: visible !important;
}

.accounts-advance-filter-grid > .flex {
  flex: 1 1 13rem !important;
  max-width: none !important;
  min-width: 13rem;
  padding: 0 !important;
}

.accounts-advance-table-card {
  background: transparent;
  margin: 0.875rem var(--oms-list-section-x, 1.5rem) 1.5rem !important;
  max-width: 100%;
  overflow: visible;
  padding: 0 !important;
}

.accounts-advance-table-scroll {
  max-width: 100%;
  overflow-x: visible;
}

.accounts-advance-table ::v-deep .v-table__overflow {
  background: #ffffff;
  border: 0.0625rem solid #e4e8f0;
  border-radius: 0 0 0.5rem 0.5rem;
  overflow-x: auto;
  width: 100%;
}

.accounts-advance-table ::v-deep table.v-table {
  border-collapse: separate;
  border-spacing: 0 0.375rem;
  min-width: var(--accounts-advance-table-min-width, 156rem);
  table-layout: fixed;
  width: 100%;
}

.accounts-advance-table ::v-deep table.v-table thead tr {
  background: transparent;
}

.accounts-advance-table ::v-deep table.v-table thead th:first-child {
  border-radius: 0.5rem 0 0 0.5rem;
}

.accounts-advance-table ::v-deep table.v-table thead th:last-child {
  border-radius: 0 0.5rem 0.5rem 0;
}

.accounts-advance-table ::v-deep table.v-table tbody tr {
  background: #ffffff;
  box-shadow: 0 0.25rem 0.875rem rgba(15, 23, 42, 0.045);
  transition: box-shadow 0.16s ease, transform 0.16s ease;
}

.accounts-advance-table ::v-deep table.v-table tbody tr:hover {
  box-shadow: 0 0.75rem 1.75rem rgba(15, 23, 42, 0.12);
  transform: translateY(-0.0625rem);
}

.accounts-advance-table ::v-deep table.v-table tbody tr:hover td {
  background: #fbfdff;
}

.accounts-advance-table ::v-deep table.v-table tbody td {
  background: #ffffff;
  border-bottom: 0.0625rem solid #e7ecf3 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 0.0625rem solid #e7ecf3 !important;
  box-sizing: border-box;
  color: #2e3748;
  font-size: 0.8125rem !important;
  height: auto;
  line-height: 1.35;
  overflow: visible;
  overflow-wrap: break-word;
  padding: 0.75rem !important;
  text-align: left !important;
  vertical-align: middle;
  white-space: normal;
  word-break: normal;
}

.accounts-advance-table ::v-deep table.v-table tbody td:first-child {
  border-left: 0.25rem solid #f58220 !important;
  border-radius: 0.5rem 0 0 0.5rem;
  color: #b95d07;
  font-weight: 800;
  padding-left: 0.5rem !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:last-child {
  border-radius: 0 0.5rem 0.5rem 0;
  border-right: 0.0625rem solid #eef1f5 !important;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(1),
.accounts-advance-table ::v-deep table.v-table td:nth-child(1) {
  width: 5.5%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(2),
.accounts-advance-table ::v-deep table.v-table td:nth-child(2) {
  text-align: center !important;
  width: 5.5%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(3),
.accounts-advance-table ::v-deep table.v-table td:nth-child(3) {
  width: 6.5%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(4),
.accounts-advance-table ::v-deep table.v-table td:nth-child(4) {
  width: 6.5%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(5),
.accounts-advance-table ::v-deep table.v-table td:nth-child(5) {
  width: 6%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(6),
.accounts-advance-table ::v-deep table.v-table td:nth-child(6) {
  width: 5%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(7),
.accounts-advance-table ::v-deep table.v-table td:nth-child(7) {
  width: 5.5%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(8),
.accounts-advance-table ::v-deep table.v-table td:nth-child(8),
.accounts-advance-table ::v-deep table.v-table th:nth-child(10),
.accounts-advance-table ::v-deep table.v-table td:nth-child(10),
.accounts-advance-table ::v-deep table.v-table th:nth-child(11),
.accounts-advance-table ::v-deep table.v-table td:nth-child(11) {
  width: 5%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(9),
.accounts-advance-table ::v-deep table.v-table td:nth-child(9) {
  width: 6.5%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(12),
.accounts-advance-table ::v-deep table.v-table td:nth-child(12) {
  width: 6%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(13),
.accounts-advance-table ::v-deep table.v-table td:nth-child(13) {
  width: 7.5%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(14),
.accounts-advance-table ::v-deep table.v-table td:nth-child(14),
.accounts-advance-table ::v-deep table.v-table th:nth-child(15),
.accounts-advance-table ::v-deep table.v-table td:nth-child(15) {
  width: 6%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(16),
.accounts-advance-table ::v-deep table.v-table td:nth-child(16) {
  width: 6.5%;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(17),
.accounts-advance-table ::v-deep table.v-table td:nth-child(17) {
  width: 6%;
}

.accounts-advance-table
  ::v-deep
  table.v-table
  th:nth-child(n + 7):nth-child(-n + 13),
.accounts-advance-table
  ::v-deep
  table.v-table
  td:nth-child(n + 7):nth-child(-n + 13) {
  text-align: right !important;
}

.accounts-advance-table ::v-deep table.v-table th:nth-child(14),
.accounts-advance-table ::v-deep table.v-table td:nth-child(14),
.accounts-advance-table ::v-deep table.v-table th:nth-child(15),
.accounts-advance-table ::v-deep table.v-table td:nth-child(15),
.accounts-advance-table ::v-deep table.v-table th:nth-child(17),
.accounts-advance-table ::v-deep table.v-table td:nth-child(17) {
  text-align: center !important;
}

.accounts-advance-table ::v-deep .accounts-advance-status-text {
  align-items: center;
  background: #f1f5f9;
  border-radius: 999rem;
  color: #475569;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 800;
  justify-content: center;
  line-height: 1.2;
  margin-top: 0.375rem;
  min-height: 1.75rem;
  padding: 0.375rem 0.625rem;
  text-align: center;
}

.accounts-advance-table ::v-deep .accounts-advance-status-text--failed {
  background: #fef2f2;
  color: #b91c1c;
}

.accounts-advance-table ::v-deep .assign-ass-btn,
.accounts-advance-table ::v-deep .doc-ass-btn,
.accounts-advance-table ::v-deep .blue-button {
  align-items: center !important;
  background: #f58220 !important;
  border: 0 !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 0.3125rem 0.75rem rgba(245, 130, 32, 0.24) !important;
  color: #ffffff !important;
  cursor: pointer;
  display: inline-flex !important;
  font-family: inherit;
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  justify-content: center;
  letter-spacing: 0 !important;
  line-height: 0.875rem !important;
  margin: 0 auto 0.5rem !important;
  min-height: 2rem !important;
  min-width: max-content !important;
  padding: 0.5rem 0.75rem !important;
  text-decoration: none !important;
  text-transform: none !important;
  white-space: nowrap !important;
}

.accounts-advance-table ::v-deep .assign-ass-btn:hover,
.accounts-advance-table ::v-deep .doc-ass-btn:hover,
.accounts-advance-table ::v-deep .blue-button:hover {
  box-shadow: 0 0.5625rem 1.125rem rgba(245, 130, 32, 0.3) !important;
  transform: translateY(-0.0625rem);
}

.accounts-advance-table ::v-deep .download-ass-btn {
  align-items: center !important;
  background: #2563eb !important;
  border: 0 !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 0.3125rem 0.75rem rgba(37, 99, 235, 0.2) !important;
  color: #ffffff !important;
  display: inline-flex !important;
  font-family: inherit;
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  justify-content: center;
  line-height: 0.875rem !important;
  margin: 0 auto 0.5rem !important;
  min-height: 2rem !important;
  min-width: max-content !important;
  padding: 0.5rem 0.625rem !important;
  text-decoration: none !important;
  white-space: nowrap !important;
}

.accounts-advance-table ::v-deep .pay-ass-btn.grey-button,
.accounts-advance-table ::v-deep .account-disabled-ass-btn {
  align-items: center !important;
  background: #f8fafc !important;
  border: 0.0625rem solid #e2e8f0 !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  color: #94a3b8 !important;
  cursor: not-allowed;
  display: inline-flex !important;
  font-family: inherit;
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  justify-content: center;
  letter-spacing: 0 !important;
  line-height: 0.875rem !important;
  margin: 0 auto 0.5rem !important;
  min-height: 2rem !important;
  min-width: max-content !important;
  padding: 0.5rem 0.75rem !important;
  text-decoration: none !important;
  text-transform: none !important;
  white-space: nowrap !important;
}

.accounts-advance-table ::v-deep .v-icon {
  vertical-align: middle;
}
.tra-ass-btn {
  text-decoration: none;
  margin: 7px !important;
  color: white;
  background-color: #ea7a1c;
  border-radius: 5px;
  border: 2px solid #ea7a1c;
  padding: 6px 6px;
}
.orange-text {
  color: #ea7a1c;
}

.download-ass-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: blue;
  border-radius: 5px;
  border: 2px solid blue;
  padding: 4px 5px;
  margin-right: 2px;
}
.spMargin {
  margin-top: -21px;
}
.red-text {
  color: red;
  animation: animate 1.5s linear infinite;
}
.red-text2 {
  color: red;
}
.account-disabled-ass-btn {
  text-decoration: none;
  color: lightgray;
  border: 2px solid lightgray;
  padding: 2px 8px;
  border-radius: 5px;
}

/* Final compact pass for Assignment Payment Details. */
.accounts-advance-page {
  --accounts-advance-table-min-width: 100%;
}

.accounts-advance-page ::v-deep .accounts-primary-tabs {
  margin: 0 !important;
  padding: 0 !important;
}

.accounts-advance-bulk-actions {
  padding: 0.625rem var(--oms-list-section-x, 1.5rem) 0 !important;
}

.accounts-advance-page .bg-clr {
  padding: 0.75rem 1rem !important;
}

.accounts-advance-page .accounts-payment-summary-grid {
  display: grid !important;
  gap: 0.625rem 0.75rem !important;
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  margin: 0 !important;
  padding: 0.5rem 1rem 0.25rem !important;
  width: 100%;
}

.accounts-advance-page .accounts-payment-summary-grid > .flex {
  flex: none !important;
  max-width: none !important;
  min-width: 0 !important;
  padding-right: 0 !important;
  width: auto !important;
}

.accounts-advance-page
  .accounts-payment-summary-grid
  > .flex
  > .layout:first-child {
  margin-bottom: 0.25rem;
}

.accounts-advance-page
  .accounts-payment-summary-grid
  > .flex
  > .layout:first-child
  span {
  color: var(--oms-primary, #ea7a1c) !important;
  font-size: 0.6875rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.02em;
  line-height: 1.2;
}

.accounts-advance-page
  .accounts-payment-summary-grid
  > .flex
  > .layout:not(:first-child) {
  align-items: center;
  display: grid !important;
  gap: 0.375rem !important;
  grid-template-columns: 3.25rem minmax(0, 1fr);
  margin: 0 !important;
  min-height: 1.75rem;
}

.accounts-advance-page
  .accounts-payment-summary-grid
  > .flex
  > .layout:not(:first-child)
  > .flex {
  flex: none !important;
  max-width: 100% !important;
  min-width: 0 !important;
  padding: 0 !important;
  width: auto !important;
}

.accounts-advance-page
  .accounts-payment-summary-grid
  > .flex
  > .layout:not(:first-child)
  .muted {
  color: var(--oms-muted, #74716a) !important;
  font-size: 0.625rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.04em;
  line-height: 1.2;
  text-transform: uppercase;
}

.accounts-advance-page .total.avatar {
  align-items: center !important;
  border-radius: 0.5rem !important;
  height: 1.75rem !important;
  justify-content: center !important;
  max-width: 100%;
  min-height: 1.75rem !important;
  min-width: 4.5rem !important;
  overflow: hidden;
  padding: 0.125rem 0.5rem !important;
  text-align: center;
  width: auto !important;
}

.accounts-advance-page .total.avatar span {
  font-size: 0.625rem !important;
  line-height: 1.2 !important;
}

.accounts-advance-page .total.avatar .count {
  font-size: 0.8125rem !important;
  font-weight: 800 !important;
  line-height: 1.1 !important;
  margin: 0 !important;
  max-width: 100%;
  white-space: nowrap;
}

.accounts-advance-filter-panel {
  margin: 0.875rem var(--oms-list-section-x, 1.5rem) 0 !important;
  padding: 0.75rem 0.875rem !important;
}

.accounts-advance-filter-panel ::v-deep .oms-filter-board__grid {
  gap: 0.75rem !important;
  grid-template-columns: repeat(auto-fit, minmax(12.5rem, 1fr)) !important;
}

.accounts-advance-filter-panel ::v-deep .oms-filter-board__field,
.accounts-advance-filter-panel ::v-deep .oms-filter-board__actions {
  height: var(--oms-filter-control-height, 2.625rem) !important;
  min-height: var(--oms-filter-control-height, 2.625rem) !important;
  padding: 0 !important;
}

.accounts-advance-filter-panel ::v-deep .oms-filter-board__field--search,
.accounts-advance-filter-panel ::v-deep .oms-filter-board__field--wide {
  grid-column: span 2;
}

.accounts-advance-table-card {
  box-sizing: border-box;
  margin: 0.875rem var(--oms-list-section-x, 1.5rem) 1.5rem !important;
  max-width: calc(100% - 3rem) !important;
  padding: 0 !important;
  width: calc(100% - 3rem) !important;
}

.accounts-advance-table-scroll,
.accounts-advance-table {
  box-sizing: border-box;
  max-width: 100% !important;
  width: 100% !important;
}

.accounts-advance-table ::v-deep .v-table__overflow {
  box-sizing: border-box;
  border-color: #ebe9e2 !important;
  border-radius: 0.5rem !important;
  max-width: 100% !important;
  overflow-x: hidden !important;
  width: 100% !important;
}

.accounts-advance-table ::v-deep table.v-table {
  border-spacing: 0 0.25rem !important;
  min-width: var(--accounts-advance-table-min-width) !important;
  max-width: 100% !important;
  width: 100% !important;
}

.accounts-advance-table ::v-deep table.v-table thead th {
  background: #faf9f6 !important;
  color: #9e9a91 !important;
  font-size: 0.6875rem !important;
  font-weight: 600 !important;
  height: 2.25rem !important;
  letter-spacing: 0.06em !important;
  line-height: 1.15 !important;
  padding: 0.5rem !important;
  text-transform: uppercase !important;
}

.accounts-advance-table ::v-deep table.v-table tbody tr {
  box-shadow: none !important;
  cursor: pointer;
}

.accounts-advance-table ::v-deep table.v-table tbody tr:hover {
  box-shadow: none !important;
  transform: none !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td {
  color: #3a382f !important;
  font-size: 0.8125rem !important;
  font-weight: 500 !important;
  line-height: 1.25 !important;
  padding: 0.5rem !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:first-child {
  border-left-width: 0.1875rem !important;
  font-weight: 700 !important;
}

.accounts-advance-table ::v-deep .layout {
  gap: 0.25rem !important;
}

.accounts-advance-table ::v-deep .v-input--selection-controls {
  margin: 0 !important;
  padding: 0 !important;
}

.accounts-advance-table ::v-deep .v-input--selection-controls .v-input__slot {
  margin: 0 !important;
}

.accounts-advance-table ::v-deep .accounts-advance-status-text {
  font-size: 0.6875rem !important;
  font-weight: 600 !important;
  margin-top: 0.25rem !important;
  min-height: 1.375rem !important;
  padding: 0.1875rem 0.5rem !important;
}

.accounts-advance-table ::v-deep .assign-ass-btn,
.accounts-advance-table ::v-deep .doc-ass-btn,
.accounts-advance-table ::v-deep .blue-button,
.accounts-advance-table ::v-deep .download-ass-btn,
.accounts-advance-table ::v-deep .pay-ass-btn.grey-button,
.accounts-advance-table ::v-deep .account-disabled-ass-btn {
  border-radius: 0.375rem !important;
  box-shadow: none !important;
  font-size: 0.6875rem !important;
  font-weight: 700 !important;
  line-height: 1.1 !important;
  margin: 0.125rem auto !important;
  min-height: 1.75rem !important;
  min-width: 0 !important;
  padding: 0.375rem 0.5rem !important;
  white-space: normal !important;
}

.accounts-advance-table ::v-deep .v-icon,
.accounts-advance-table ::v-deep .theme--light.v-icon {
  font-size: 0.875rem !important;
}

/* Readability pass for mixed value/action cells. */
.accounts-advance-table ::v-deep table.v-table tbody td.accounts-advance-customer-details-cell {
  line-height: 1.45 !important;
  padding: 0.75rem 0.625rem !important;
  text-align: center !important;
}

.accounts-advance-table ::v-deep .accounts-advance-customer-details-text {
  display: block;
  margin: 0 auto 0.5rem;
}

.accounts-advance-table ::v-deep .accounts-advance-customer-details-action {
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
  text-align: center;
}

.accounts-advance-table ::v-deep .accounts-advance-customer-details-action .view-ass-btn {
  display: inline-flex !important;
  margin: 0 auto !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(4),
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(5) {
  line-height: 1.45 !important;
  padding: 0.75rem 0.625rem !important;
  text-align: center !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(4) > span,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(4) > div,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(5) > span,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(5) > div {
  display: block;
  margin: 0 auto 0.45rem;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(4) .log,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(4) .font_Bold,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(5) .log,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(5) .font_Bold {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0.5rem;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(4) .view-ass-btn,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(5) .view-ass-btn {
  display: inline-flex !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(10),
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(11),
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12),
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(13),
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(14),
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(15) {
  line-height: 1.4 !important;
  padding: 0.75rem 0.625rem !important;
  text-align: center !important;
  vertical-align: middle !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(10) > .layout,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(11) > .layout,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12) > .layout,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(13) > .layout,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(14) > .layout,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(15) > .layout {
  align-items: center !important;
  display: flex !important;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0.55rem !important;
  justify-content: center !important;
  text-align: center !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(4) *,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(10) *,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(11) *,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12) *,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(13) *,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(14) *,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(15) * {
  text-align: center !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(10) .layout,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(11) .layout,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12) .layout,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(13) .layout,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(14) .layout,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(15) .layout {
  align-items: center !important;
  justify-content: center !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(10) .layout > .flex,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(11) .layout > .flex,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12) .layout > .flex,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(13) .layout > .flex,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(14) .layout > .flex,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(15) .layout > .flex {
  flex: 0 0 auto !important;
  max-width: 100% !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: auto !important;
}

.accounts-advance-table ::v-deep .accounts-invoice-actions {
  align-items: center !important;
  display: inline-flex !important;
  flex-direction: row !important;
  flex-wrap: wrap;
  gap: 0.5rem !important;
  justify-content: center !important;
  margin: 0.45rem auto 0 !important;
  max-width: 100%;
  text-align: center !important;
  width: auto !important;
}

.accounts-advance-table ::v-deep .accounts-invoice-actions > .flex {
  flex: 0 0 auto !important;
  max-width: none !important;
  padding: 0 !important;
  text-align: center !important;
  width: auto !important;
}

.accounts-advance-table ::v-deep .accounts-invoice-actions button,
.accounts-advance-table ::v-deep .accounts-invoice-actions .download-ass-btn,
.accounts-advance-table ::v-deep .accounts-invoice-actions .si-ass-btn {
  margin: 0 !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(10) > span,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(11) > span,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12) > span,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(13) > span,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(14) > span,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(15) > span,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(10) > div,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(11) > div,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12) > div,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(13) > div,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(14) > div,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(15) > div,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(10) > .flex,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(11) > .flex,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12) > .flex,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(13) > .flex,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(14) > .flex,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(15) > .flex {
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(10) .activity-log-trigger,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(11) .activity-log-trigger,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12) .activity-log-trigger,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(13) .activity-log-trigger,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(14) .activity-log-trigger,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(15) .activity-log-trigger {
  margin: 0.125rem auto !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(10) button,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(11) button,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12) button,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(13) button,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(14) button,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(15) button {
  margin: 0.1875rem auto !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td .accounts-invoice-actions button,
.accounts-advance-table ::v-deep table.v-table tbody td .accounts-invoice-actions .download-ass-btn,
.accounts-advance-table ::v-deep table.v-table tbody td .accounts-invoice-actions .si-ass-btn {
  margin: 0 !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12) > span {
  display: block;
  margin-bottom: 0.35rem;
}

/* Keep vertically stacked actions compact in Additional Charges and Final Payment. */
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12) > .layout,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(13) > .layout {
  gap: 0.3rem !important;
  padding-bottom: 0.125rem !important;
  padding-top: 0.125rem !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(12) button,
.accounts-advance-table ::v-deep table.v-table tbody td:nth-child(13) button {
  margin-bottom: 0.1rem !important;
  margin-top: 0.1rem !important;
}

/* Assignment Payment Details: summary row + expandable finance details. */
.accounts-advance-table ::v-deep table.v-table {
  display: block;
  table-layout: auto !important;
}

.accounts-advance-table ::v-deep table.v-table thead,
.accounts-advance-table ::v-deep table.v-table tbody {
  display: block;
  width: 100%;
}

.accounts-advance-table
  ::v-deep
  table.v-table
  thead
  tr:not(.v-datatable__progress),
.accounts-advance-table ::v-deep table.v-table tbody tr {
  display: grid;
  grid-template-columns: 10% 11% 18% 18% 9% 7% 7% 8% 12%;
  height: auto !important;
  width: 100%;
}

.accounts-advance-table ::v-deep table.v-table thead {
  height: 2.25rem;
  min-height: 2.25rem;
  overflow: hidden;
  position: relative;
}

.accounts-advance-table ::v-deep .v-datatable__progress {
  display: none !important;
  height: 0 !important;
  min-height: 0 !important;
  overflow: hidden !important;
  padding: 0 !important;
}

.accounts-advance-table
  ::v-deep
  table.v-table
  thead
  tr:not(.v-datatable__progress) {
  height: 2.25rem;
  min-height: 2.25rem;
}

.accounts-advance-table ::v-deep table.v-table thead tr.v-datatable__progress {
  display: block;
  height: 0;
  min-height: 0;
  width: 100%;
}

.accounts-advance-table
  ::v-deep
  table.v-table
  thead
  tr.v-datatable__progress
  th {
  display: block;
  height: 0 !important;
  padding: 0 !important;
  width: 100% !important;
}

.accounts-advance-table ::v-deep table.v-table tbody {
  margin-top: 0 !important;
}

.accounts-advance-table ::v-deep table.v-table thead th,
.accounts-advance-table ::v-deep table.v-table tbody td {
  box-sizing: border-box;
  display: block;
  height: auto !important;
  min-width: 0;
  width: auto !important;
}

.accounts-advance-table ::v-deep table.v-table thead th:last-child {
  max-width: 100%;
  overflow: hidden !important;
}

.accounts-advance-table ::v-deep table.v-table thead th {
  align-items: center;
  display: flex;
  justify-content: center;
  text-align: center !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td {
  text-align: center !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td > * {
  margin-left: auto;
  margin-right: auto;
  text-align: center !important;
}

.accounts-advance-table ::v-deep table.v-table tbody td .layout {
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
}

.accounts-advance-table ::v-deep .accounts-payment-job-cell {
  font-size: 0.6875rem !important;
  grid-column: 1;
  grid-row: 1;
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
  text-align: center !important;
}

.accounts-advance-table ::v-deep .accounts-payment-job-cell > .layout {
  flex-wrap: nowrap !important;
  gap: 0.125rem !important;
  width: 100%;
}

.accounts-advance-table ::v-deep .accounts-payment-job-cell > .layout > span {
  font-size: 0.6875rem !important;
  min-width: 0;
  white-space: nowrap;
}

.accounts-advance-table ::v-deep .accounts-payment-assignment-cell {
  cursor: pointer;
  grid-column: 2;
  grid-row: 1;
}

.accounts-advance-table ::v-deep .accounts-payment-customer-cell {
  grid-column: 3;
  grid-row: 1;
}

.accounts-advance-table ::v-deep .accounts-payment-driver-cell {
  grid-column: 4;
  grid-row: 1;
}

.accounts-advance-table ::v-deep .accounts-payment-truck-cell {
  grid-column: 5;
  grid-row: 1;
}

.accounts-advance-table ::v-deep .accounts-payment-duty-cell {
  grid-column: 6;
  grid-row: 1;
}

.accounts-advance-table ::v-deep .accounts-payment-driver-price-cell {
  grid-column: 7;
  grid-row: 1;
}

.accounts-advance-table ::v-deep .accounts-payment-invoice-cell {
  grid-column: 8;
  grid-row: 1;
}

.accounts-advance-table ::v-deep .accounts-payment-actions-cell {
  grid-column: 9;
  grid-row: 1;
}

.accounts-advance-table ::v-deep .accounts-payment-detail-cell {
  display: none;
}

.accounts-advance-table ::v-deep .accounts-payment-detail-cell--expanded {
  align-items: center;
  background: #fffdfa !important;
  border-top: 0.0625rem solid #eef1f5 !important;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  justify-content: flex-start;
  min-height: 7.25rem;
  padding: 0.875rem 1rem !important;
  position: static;
}

.accounts-advance-table
  ::v-deep
  .accounts-payment-detail-cell--expanded::before {
  color: #64748b;
  content: attr(data-detail-label);
  display: block;
  flex: 0 0 auto;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.2;
  margin: 0;
  position: static;
  text-align: center;
  text-transform: uppercase;
}

.accounts-advance-table
  ::v-deep
  .accounts-payment-detail-cell--expanded
  > * {
  flex: 0 0 auto;
  margin-bottom: 0 !important;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-top: 0 !important;
  max-width: 100%;
  text-align: center !important;
}

.accounts-advance-table ::v-deep .accounts-payment-summary-cell {
  min-height: 6.5rem;
  overflow: visible !important;
}

.accounts-advance-table ::v-deep .accounts-payment-transporter-cell {
  grid-column: 1 / 3;
  grid-row: 2;
}

.accounts-advance-table ::v-deep .accounts-payment-advance-requested-cell {
  grid-column: 3;
  grid-row: 2;
}

.accounts-advance-table ::v-deep .accounts-payment-advance-paid-cell {
  grid-column: 4;
  grid-row: 2;
}

.accounts-advance-table ::v-deep .accounts-payment-additional-cell {
  grid-column: 5 / 7;
  grid-row: 2;
}

.accounts-advance-table ::v-deep .accounts-payment-final-cell {
  grid-column: 7 / 10;
  grid-row: 2;
}

.accounts-advance-table ::v-deep .accounts-payment-purchase-cell {
  grid-column: 1 / 3;
  grid-row: 3;
}

.accounts-advance-table ::v-deep .accounts-payment-download-docs-cell {
  grid-column: 3 / 4;
  grid-row: 3;
}

.accounts-advance-table ::v-deep .accounts-payment-sales-cell {
  grid-column: 4 / 6;
  grid-row: 3;
}

.accounts-advance-table ::v-deep .accounts-payment-credit-cell {
  grid-column: 6 / 8;
  grid-row: 3;
}

.accounts-advance-table ::v-deep .accounts-payment-comments-cell {
  grid-column: 8 / 10;
  grid-row: 3;
}

.accounts-advance-table ::v-deep .accounts-payment-expand-toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
  margin: 0 !important;
  padding: 0 !important;
}

.accounts-advance-table
  ::v-deep
  .accounts-payment-summary-cell.accounts-payment-actions-cell {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  justify-content: center;
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
}

.accounts-advance-table
  ::v-deep
  .accounts-payment-summary-cell.accounts-payment-actions-cell
  button {
  box-sizing: border-box;
  font-size: 0.625rem !important;
  margin: 0 !important;
  max-width: 100%;
  min-width: 0 !important;
  padding: 0.3125rem 0.375rem !important;
  white-space: normal !important;
}

@media (max-width: 64rem) {
  .accounts-advance-filter-panel ::v-deep .oms-filter-board__field--search,
  .accounts-advance-filter-panel ::v-deep .oms-filter-board__field--wide {
    grid-column: span 1;
  }

  .accounts-advance-page .accounts-payment-summary-grid > .flex,
  .accounts-advance-filter-grid > .flex {
    min-width: 0;
  }

  .accounts-advance-table-card {
    margin-left: 0.75rem !important;
    margin-right: 0.75rem !important;
    max-width: calc(100% - 1.5rem) !important;
    width: calc(100% - 1.5rem) !important;
  }
}
@keyframes animate {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.6;
  }

  100% {
    opacity: 0;
  }
}
</style>

<style>
html #nav .accounts-advance-page .accounts-payment-summary-grid {
  display: grid !important;
  gap: 0.625rem 0.75rem !important;
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  margin: 0 !important;
  padding: 0.5rem 1rem 0.25rem !important;
  width: 100%;
}

@media (max-width: 64rem) {
  html #nav .accounts-advance-page .accounts-payment-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

html #nav .accounts-advance-page .accounts-payment-summary-grid > .flex {
  flex: none !important;
  max-width: none !important;
  min-width: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: auto !important;
}

html #nav .accounts-advance-page .accounts-payment-summary-grid > .flex > .layout:first-child span {
  color: var(--oms-primary, #ea7a1c) !important;
  font-size: 0.6875rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.02em;
  line-height: 1.2;
}

html #nav .accounts-advance-page .accounts-payment-summary-grid > .flex > .layout:not(:first-child) {
  align-items: center !important;
  display: grid !important;
  gap: 0.375rem !important;
  grid-template-columns: 3.25rem minmax(0, max-content) !important;
  margin: 0 0 0.25rem !important;
  min-height: 1.75rem;
}

html #nav .accounts-advance-page .accounts-payment-summary-grid > .flex > .layout:not(:first-child) > .flex {
  flex: none !important;
  max-width: 100% !important;
  min-width: 0 !important;
  padding: 0 !important;
  width: auto !important;
}

html #nav .accounts-advance-page .accounts-payment-summary-grid .muted {
  color: var(--oms-muted, #74716a) !important;
  font-size: 0.625rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.04em;
  line-height: 1.2;
  text-transform: uppercase;
}

html #nav .accounts-advance-page .accounts-payment-summary-grid > .flex > .layout:not(:first-child) > .flex.pt-3 {
  padding-top: 0 !important;
}

html #nav .accounts-advance-page .total.avatar,
html #nav .accounts-advance-page .v-avatar.total.avatar {
  align-items: center !important;
  background: var(--oms-surface, #ffffff) !important;
  border: 1px solid var(--oms-primary, #ea7a1c) !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  color: var(--oms-ink-strong, #1a1916) !important;
  display: inline-flex !important;
  height: 1.75rem !important;
  justify-content: center !important;
  max-height: 1.75rem !important;
  max-width: 100%;
  min-height: 1.75rem !important;
  min-width: 4.5rem !important;
  overflow: hidden !important;
  padding: 0.125rem 0.5rem !important;
  text-align: center;
  width: auto !important;
}

html #nav .accounts-advance-page .total.avatar span {
  color: var(--oms-ink-strong, #1a1916) !important;
  font-size: 0.625rem !important;
  line-height: 1.2 !important;
  text-transform: none !important;
}

html #nav .accounts-advance-page .total.avatar .count,
html #nav .accounts-advance-page .total.avatar .breakword {
  color: var(--oms-ink-strong, #1a1916) !important;
  display: block !important;
  font-family: inherit !important;
  font-size: 0.8125rem !important;
  font-weight: 800 !important;
  line-height: 1.1 !important;
  margin: 0 !important;
  max-width: 100%;
  padding: 0 !important;
  white-space: nowrap;
}

html.oms-night-mode #nav .accounts-advance-page {
  background: transparent !important;
  color: var(--oms-ink) !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-primary-tabs {
  background: var(--oms-segmented-bg) !important;
  border-color: var(--oms-border) !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-bulk-actions,
html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table-card,
html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table-scroll {
  background: transparent !important;
}

html.oms-night-mode #nav .accounts-advance-page .bg-clr,
html.oms-night-mode #nav .accounts-advance-page .accounts-advance-filter-panel {
  background: var(--oms-surface) !important;
  border-color: var(--oms-border) !important;
  box-shadow: none !important;
  color: var(--oms-ink) !important;
}

html.oms-night-mode #nav .accounts-advance-page .bg-clr span,
html.oms-night-mode #nav .accounts-advance-page .bg-clr .muted,
html.oms-night-mode #nav .accounts-advance-page .bg-clr .count {
  color: var(--oms-ink) !important;
}

html.oms-night-mode #nav .accounts-advance-page .total.avatar,
html.oms-night-mode #nav .accounts-advance-page .v-avatar.total.avatar {
  background: var(--oms-surface-soft) !important;
  border: 1px solid var(--oms-border) !important;
  box-shadow: none !important;
  height: 1.75rem !important;
  max-height: 1.75rem !important;
  min-height: 1.75rem !important;
  min-width: 4.5rem !important;
  padding: 0.125rem 0.5rem !important;
  width: auto !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table .v-table__overflow {
  background: var(--oms-surface) !important;
  border-color: var(--oms-border) !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table table.v-table {
  background: transparent !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table table.v-table thead tr,
html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table table.v-table thead th {
  background: var(--oms-table-header-bg) !important;
  border-color: var(--oms-border-strong) !important;
  color: #dce3ff !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table table.v-table tbody tr {
  background: transparent !important;
  box-shadow: none !important;
  transform: none !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table table.v-table tbody tr:hover td {
  background: var(--oms-surface-raised) !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table table.v-table tbody td {
  background: var(--oms-surface) !important;
  border-color: var(--oms-border) !important;
  color: var(--oms-ink) !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table table.v-table tbody td:first-child {
  border-left-color: var(--oms-primary) !important;
  color: #f8bd82 !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table table.v-table tbody td:last-child {
  border-right-color: var(--oms-border) !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table .accounts-advance-status-text {
  background: rgba(220, 227, 255, 0.1) !important;
  border: 1px solid var(--oms-border) !important;
  color: var(--oms-ink) !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table .accounts-advance-status-text--failed {
  background: rgba(239, 68, 68, 0.14) !important;
  border-color: rgba(248, 113, 113, 0.28) !important;
  color: #fca5a5 !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table .pay-ass-btn.grey-button,
html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table .account-disabled-ass-btn {
  background: rgba(220, 227, 255, 0.08) !important;
  border-color: var(--oms-border) !important;
  color: var(--oms-muted) !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table .assign-ass-btn,
html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table .doc-ass-btn,
html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table .blue-button,
html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table .download-ass-btn {
  box-shadow: none !important;
  color: #ffffff !important;
}

html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table .v-icon,
html.oms-night-mode #nav .accounts-advance-page .accounts-advance-table .material-icons {
  color: inherit !important;
}

</style>
